export const CIS_PHONES = {
  AM: [
    {
      phone: 80000001,
      formatted: '+374 80 000-001',
      raw: '+37480000001',
    },
    {
      phone: '0312-32733, 031-67267',
      formatted: '+374 31 232-733',
      raw: '+37431232733',
    },
    {
      phone: '(0322) 2-04-14',
      formatted: '+374 32 220-414',
      raw: '+37432220414',
    },
    {
      phone: '0322-24090, 0322-41164',
      formatted: '+374 32 241-164',
      raw: '+37432241164',
    },
    {
      phone: '055 360303, 012 300303',
      formatted: '+374 12 300-303',
      raw: '+37412300303',
    },
    {
      phone: '0 8000 00 01',
      formatted: '+374 80 000-001',
      raw: '+37480000001',
    },
    {
      phone: '(37402) 223-79-18',
      formatted: '+374 22 237-918',
      raw: '+37422237918',
    },
    {
      phone: '+374 0312 3 03 11',
      formatted: '+374 31 230-311',
      raw: '+37431230311',
    },
    {
      phone: '(374) 033-64-61-60',
      formatted: '+374 33 646-160',
      raw: '+37433646160',
    },
    {
      phone: '(374) 060-65-15-15',
      formatted: '+374 60 651-515',
      raw: '+37460651515',
    },
    {
      phone: '+374 (077) 02-70-67',
      formatted: '+374 77 027-067',
      raw: '+37477027067',
    },
    {
      phone: '(37409) 312-21-93',
      formatted: '+374 93 122-193',
      raw: '+37493122193',
    },
    {
      phone: '(37409) 477–27-14',
      formatted: '+374 94 772-714',
      raw: '+37494772714',
    },
    {
      phone: '(374) 10-200-250',
      formatted: '+374 10 200-250',
      raw: '+37410200250',
    },
    {
      phone: '(374) 10-20-30-91',
      formatted: '+374 10 203-091',
      raw: '+37410203091',
    },
    {
      phone: '(374) 10-20-40-80',
      formatted: '+374 10 204-080',
      raw: '+37410204080',
    },
    {
      phone: '(374) 10-20-50-50',
      formatted: '+374 10 205-050',
      raw: '+37410205050',
    },
    {
      phone: '(374) 10-20-61-03',
      formatted: '+374 10 206-103',
      raw: '+37410206103',
    },
    {
      phone: '(374) 10-20-70-07',
      formatted: '+374 10 207-007',
      raw: '+37410207007',
    },
    {
      phone: '+374 10 20 96 16',
      formatted: '+374 10 209-616',
      raw: '+37410209616',
    },
    {
      phone: '(374) 10-22-33-23',
      formatted: '+374 10 223-323',
      raw: '+37410223323',
    },
    {
      phone: '(374) 10-22-33-73',
      formatted: '+374 10 223-373',
      raw: '+37410223373',
    },
    {
      phone: '(374) 10-23-01-99',
      formatted: '+374 10 230-199',
      raw: '+37410230199',
    },
    {
      phone: '(374) 10-23-13-29',
      formatted: '+374 10 231-329',
      raw: '+37410231329',
    },
    {
      phone: '(374) 10 23-56-54',
      formatted: '+374 10 235-654',
      raw: '+37410235654',
    },
    {
      phone: '(374) 10-25-59-28',
      formatted: '+374 10 255-928',
      raw: '+37410255928',
    },
    {
      phone: '(374) 10-26-82-23',
      formatted: '+374 10 268-223',
      raw: '+37410268223',
    },
    {
      phone: '(374) 10-27-08-08',
      formatted: '+374 10 270-808',
      raw: '+37410270808',
    },
    {
      phone: '(374) 10 27-57-41',
      formatted: '+374 10 275-741',
      raw: '+37410275741',
    },
    {
      phone: '+374 (10) 282020',
      formatted: '+374 10 282-020',
      raw: '+37410282020',
    },
    {
      phone: '(374) 10-28-22-82',
      formatted: '+374 10 282-282',
      raw: '+37410282282',
    },
    {
      phone: '(374) 10 28-63-20',
      formatted: '+374 10 286-320',
      raw: '+37410286320',
    },
    {
      phone: '+374 10 289528 +374 55 422211',
      formatted: '+374 55 422-211',
      raw: '+37455422211',
    },
    {
      phone: '(374) 10-303010',
      formatted: '+374 10 303-010',
      raw: '+37410303010',
    },
    {
      phone: '(374) 10 30-32-32',
      formatted: '+374 10 303-232',
      raw: '+37410303232',
    },
    {
      phone: '(374) 10-318109',
      formatted: '+374 10 318-109',
      raw: '+37410318109',
    },
    {
      phone: '(374) 10-32-06-60',
      formatted: '+374 10 320-660',
      raw: '+37410320660',
    },
    {
      phone: '+374 (10) 322211',
      formatted: '+374 10 322-211',
      raw: '+37410322211',
    },
    {
      phone: '(374) 10-32-32-06',
      formatted: '+374 10 323-206',
      raw: '+37410323206',
    },
    {
      phone: '(374) 10-34-17-74',
      formatted: '+374 10 341-774',
      raw: '+37410341774',
    },
    {
      phone: '(374) 10-344944',
      formatted: '+374 10 344-944',
      raw: '+37410344944',
    },
    {
      phone: '(374) 10 35-44-03',
      formatted: '+374 10 354-403',
      raw: '+37410354403',
    },
    {
      phone: '(374) 10 36-92-70',
      formatted: '+374 10 369-270',
      raw: '+37410369270',
    },
    {
      phone: '(374) 10-38-00-88',
      formatted: '+374 10 380-088',
      raw: '+37410380088',
    },
    {
      phone: '(374) 10 38-18-68',
      formatted: '+374 10 381-868',
      raw: '+37410381868',
    },
    {
      phone: '(374) 10-42-10-30',
      formatted: '+374 10 421-030',
      raw: '+37410421030',
    },
    {
      phone: '(374) 10-42-43-40',
      formatted: '+374 10 424-340',
      raw: '+37410424340',
    },
    {
      phone: '+374 10 42-83-11, +374 11 42-83-11',
      formatted: '+374 11 428-311',
      raw: '+37411428311',
    },
    {
      phone: '(374) 10 44-02-32',
      formatted: '+374 10 440-232',
      raw: '+37410440232',
    },
    {
      phone: '(374) 10 44-84-21',
      formatted: '+374 10 448-421',
      raw: '+37410448421',
    },
    {
      phone: '+374 10 450 230',
      formatted: '+374 10 450-230',
      raw: '+37410450230',
    },
    {
      phone: '(374) 10 45-11-41',
      formatted: '+374 10 451-141',
      raw: '+37410451141',
    },
    {
      phone: '(374) 10-46-60-62',
      formatted: '+374 10 466-062',
      raw: '+37410466062',
    },
    {
      phone: '(374) 10-47-11-00',
      formatted: '+374 10 471-100',
      raw: '+37410471100',
    },
    {
      phone: '(374) 10-483879',
      formatted: '+374 10 483-879',
      raw: '+37410483879',
    },
    {
      phone: '(374) 10-50-00-24',
      formatted: '+374 10 500-024',
      raw: '+37410500024',
    },
    {
      phone: '+374 10 50-99-99',
      formatted: '+374 10 509-999',
      raw: '+37410509999',
    },
    {
      phone: '+374 10 521442',
      formatted: '+374 10 521-442',
      raw: '+37410521442',
    },
    {
      phone: '(374)10 52-23-32',
      formatted: '+374 10 522-332',
      raw: '+37410522332',
    },
    {
      phone: '(374) 10-522882',
      formatted: '+374 10 522-882',
      raw: '+37410522882',
    },
    {
      phone: '(374) 10-52-55-58',
      formatted: '+374 10 525-558',
      raw: '+37410525558',
    },
    {
      phone: '(374) 10-52-80-90',
      formatted: '+374 10 528-090',
      raw: '+37410528090',
    },
    {
      phone: '+374 (10) 528444',
      formatted: '+374 10 528-444',
      raw: '+37410528444',
    },
    {
      phone: '(374) 10-52-96-80',
      formatted: '+374 10 529-680',
      raw: '+37410529680',
    },
    {
      phone: '(374) 10-530641',
      formatted: '+374 10 530-641',
      raw: '+37410530641',
    },
    {
      phone: '(374) 10-530801',
      formatted: '+374 10 530-801',
      raw: '+37410530801',
    },
    {
      phone: '(+374) 10 53 40 63',
      formatted: '+374 10 534-063',
      raw: '+37410534063',
    },
    {
      phone: '(374) 10 53-57-71',
      formatted: '+374 10 535-771',
      raw: '+37410535771',
    },
    {
      phone: '+374 (10) 536949',
      formatted: '+374 10 536-949',
      raw: '+37410536949',
    },
    {
      phone: '(374) 10-53-75-00',
      formatted: '+374 10 537-500',
      raw: '+37410537500',
    },
    {
      phone: '(374) 10-53-85-81',
      formatted: '+374 10 538-581',
      raw: '+37410538581',
    },
    {
      phone: '+374-10-54-24-24, +374-55-42-22-06',
      formatted: '+374 55 422-206',
      raw: '+37455422206',
    },
    {
      phone: '(374) 10 54-43-33',
      formatted: '+374 10 544-333',
      raw: '+37410544333',
    },
    {
      phone: '(374) 10-54-45-54',
      formatted: '+374 10 544-554',
      raw: '+37410544554',
    },
    {
      phone: '(374) 10-55-24-60',
      formatted: '+374 10 552-460',
      raw: '+37410552460',
    },
    {
      phone: '(374) 10 56-52-54',
      formatted: '+374 10 565-254',
      raw: '+37410565254',
    },
    {
      phone: '(374) 10-56-99-25',
      formatted: '+374 10 569-925',
      raw: '+37410569925',
    },
    {
      phone: '(374) 10 569949',
      formatted: '+374 10 569-949',
      raw: '+37410569949',
    },
    {
      phone: '(374) 10-57-88-88',
      formatted: '+374 10 578-888',
      raw: '+37410578888',
    },
    {
      phone: '(374) 10-58-22-44',
      formatted: '+374 10 582-244',
      raw: '+37410582244',
    },
    {
      phone: '+374 (10) 583536',
      formatted: '+374 10 583-536',
      raw: '+37410583536',
    },
    {
      phone: '(374) 10 58-36-64',
      formatted: '+374 10 583-664',
      raw: '+37410583664',
    },
    {
      phone: '(374) 10-58-88-78',
      formatted: '+374 10 588-878',
      raw: '+37410588878',
    },
    {
      phone: '(374) 10 61-07-32',
      formatted: '+374 10 610-732',
      raw: '+37410610732',
    },
    {
      phone: '(374) 10 61-99-99',
      formatted: '+374 10 619-999',
      raw: '+37410619999',
    },
    {
      phone: '(374) 10-65-07-17',
      formatted: '+374 10 650-717',
      raw: '+37410650717',
    },
    {
      phone: '+374 10 655930',
      formatted: '+374 10 655-930',
      raw: '+37410655930',
    },
    {
      phone: '(374) 10 74-19-10',
      formatted: '+374 10 741-910',
      raw: '+37410741910',
    },
    {
      phone: '(374) 10-75-00-85',
      formatted: '+374 10 750-085',
      raw: '+37410750085',
    },
    {
      phone: '(374) 10-75-50-75',
      formatted: '+374 10 755-075',
      raw: '+37410755075',
    },
    {
      phone: '374 (10) 75-55-77',
      formatted: '+374 10 755-577',
      raw: '+37410755577',
    },
    {
      phone: '(374) 10-75-75-70',
      formatted: '+374 10 757-570',
      raw: '+37410757570',
    },
    {
      phone: '(374) 11-20-00-00',
      formatted: '+374 11 200-000',
      raw: '+37411200000',
    },
    {
      phone: '(374) 11 20-03-03',
      formatted: '+374 11 200-303',
      raw: '+37411200303',
    },
    {
      phone: '(374) 11-21-02-20',
      formatted: '+374 11 210-220',
      raw: '+37411210220',
    },
    {
      phone: '(374) 11 21-15-11',
      formatted: '+374 11 211-511',
      raw: '+37411211511',
    },
    {
      phone: '(374) 11-22-00-24',
      formatted: '+374 11 220-024',
      raw: '+37411220024',
    },
    {
      phone: '(374) 11-23-01-99',
      formatted: '+374 11 230-199',
      raw: '+37411230199',
    },
    {
      phone: '(374) 11-231329',
      formatted: '+374 11 231-329',
      raw: '+37411231329',
    },
    {
      phone: '(374) 11-238080',
      formatted: '+374 11 238-080',
      raw: '+37411238080',
    },
    {
      phone: '(374) 11-24-01-99',
      formatted: '+374 11 240-199',
      raw: '+37411240199',
    },
  ],
  AZ: [
    {
      phone: '(012) 310-09-11, (012) 498-89-11 (050) 250-49-11',
      formatted: '+994 50 250-49-11',
      raw: '+994502504911',
    },
    {
      phone: '(012) 497-11-41, (012) 525-17-56, (050) 200-06-70',
      formatted: '+994 50 200-06-70',
      raw: '+994502000670',
    },
    {
      phone: '(018) 658-51-81',
      formatted: '+994 18 658-51-81',
      raw: '+994186585181',
    },
    {
      phone: '(022) 268-87-44, (050) 223-04-51',
      formatted: '+994 50 223-04-51',
      raw: '+994502230451',
    },
    {
      phone: '(994) 05 10-22-310',
      formatted: '+994 05 102-23-10',
      raw: '+994051022310',
    },
    {
      phone: '(9940 55 255-38-07',
      formatted: '+994 55 255-38-07',
      raw: '+994552553807',
    },
    {
      phone: '(994) 099 755-69-00',
      formatted: '+994 99 755-69-00',
      raw: '+994997556900',
    },
    {
      phone: '(994) 10 265-77-97',
      formatted: '+994 10 265-77-97',
      raw: '+994102657797',
    },
    {
      phone: '(994) 10 317-01-22',
      formatted: '+994 10 317-01-22',
      raw: '+994103170122',
    },
    {
      phone: '(994) 10 334-03-03',
      formatted: '+994 10 334-03-03',
      raw: '+994103340303',
    },
    {
      phone: '(994) 10 430-93-23',
      formatted: '+994 10 430-93-23',
      raw: '+994104309323',
    },
    {
      phone: '(994) 10 511-08-01',
      formatted: '+994 10 511-08-01',
      raw: '+994105110801',
    },
    {
      phone: '(994) 12 210-10-50',
      formatted: '+994 12 210-10-50',
      raw: '+994122101050',
    },
    {
      phone: '(994) 12 310-00-22',
      formatted: '+994 12 310-00-22',
      raw: '+994123100022',
    },
    {
      phone: '(994) 12 310-03-33',
      formatted: '+994 12 310-03-33',
      raw: '+994123100333',
    },
    {
      phone: '(994) 12 310-07-88',
      formatted: '+994 12 310-07-88',
      raw: '+994123100788',
    },
    {
      phone: '(994) 12 310-17-77',
      formatted: '+994 12 310-17-77',
      raw: '+994123101777',
    },
    {
      phone: '(994) 12 310-35-06',
      formatted: '+994 12 310-35-06',
      raw: '+994123103506',
    },
    {
      phone: '(994) 12 310-83-50',
      formatted: '+994 12 310-83-50',
      raw: '+994123108350',
    },
    {
      phone: '(994) 12 311-02-22',
      formatted: '+994 12 311-02-22',
      raw: '+994123110222',
    },
    {
      phone: '(994) 12 371-59-28',
      formatted: '+994 12 371-59-28',
      raw: '+994123715928',
    },
    {
      phone: '(994) 12 371-88-61',
      formatted: '+994 12 371-88-61',
      raw: '+994123718861',
    },
    {
      phone: '(994) 12 373-07-45',
      formatted: '+994 12 373-07-45',
      raw: '+994123730745',
    },
    {
      phone: '(994) 12 373-11-50',
      formatted: '+994 12 373-11-50',
      raw: '+994123731150',
    },
    {
      phone: '(994) 12 374-70-93',
      formatted: '+994 12 374-70-93',
      raw: '+994123747093',
    },
    {
      phone: '(994) 12 374-75-18',
      formatted: '+994 12 374-75-18',
      raw: '+994123747518',
    },
    {
      phone: '(994) 12 374-94-34',
      formatted: '+994 12 374-94-34',
      raw: '+994123749434',
    },
    {
      phone: '(994) 12 375-20-07',
      formatted: '+994 12 375-20-07',
      raw: '+994123752007',
    },
    {
      phone: '(994) 12 375-46-22',
      formatted: '+994 12 375-46-22',
      raw: '+994123754622',
    },
    {
      phone: '(994) 12 375-51-75',
      formatted: '+994 12 375-51-75',
      raw: '+994123755175',
    },
    {
      phone: '(994) 12 375-59-10',
      formatted: '+994 12 375-59-10',
      raw: '+994123755910',
    },
    {
      phone: '(994) 12 404-14-04',
      formatted: '+994 12 404-14-04',
      raw: '+994124041404',
    },
    {
      phone: '(994) 12 404-32-49',
      formatted: '+994 12 404-32-49',
      raw: '+994124043249',
    },
    {
      phone: '(994) 12 404-41-90',
      formatted: '+994 12 404-41-90',
      raw: '+994124044190',
    },
    {
      phone: '(994) 12 404-44-69',
      formatted: '+994 12 404-44-69',
      raw: '+994124044469',
    },
    {
      phone: '(994) 12 404-76-06',
      formatted: '+994 12 404-76-06',
      raw: '+994124047606',
    },
    {
      phone: '(994) 12 409-90-91',
      formatted: '+994 12 409-90-91',
      raw: '+994124099091',
    },
    {
      phone: '(994) 12 421-36-68',
      formatted: '+994 12 421-36-68',
      raw: '+994124213668',
    },
    {
      phone: '(994) 12 425-00-24',
      formatted: '+994 12 425-00-24',
      raw: '+994124250024',
    },
    {
      phone: '(994) 12 430-42-77',
      formatted: '+994 12 430-42-77',
      raw: '+994124304277',
    },
    {
      phone: '(994) 12 430-89-89',
      formatted: '+994 12 430-89-89',
      raw: '+994124308989',
    },
    {
      phone: '(994) 12 431-12-24',
      formatted: '+994 12 431-12-24',
      raw: '+994124311224',
    },
    {
      phone: '(994) 12 431-13-14',
      formatted: '+994 12 431-13-14',
      raw: '+994124311314',
    },
    {
      phone: '(994) 12 431-35-31',
      formatted: '+994 12 431-35-31',
      raw: '+994124313531',
    },
    {
      phone: '994 (12) 431‒98‒41',
      formatted: '+994 12 431-98-41',
      raw: '+994124319841',
    },
    {
      phone: '(994) 12 432-29-10',
      formatted: '+994 12 432-29-10',
      raw: '+994124322910',
    },
    {
      phone: '(994) 12 432-89-56',
      formatted: '+994 12 432-89-56',
      raw: '+994124328956',
    },
    {
      phone: '(994) 12 433-09-29',
      formatted: '+994 12 433-09-29',
      raw: '+994124330929',
    },
    {
      phone: '(994) 12 433-82-17',
      formatted: '+994 12 433-82-17',
      raw: '+994124338217',
    },
    {
      phone: '(994) 12 436-14-96',
      formatted: '+994 12 436-14-96',
      raw: '+994124361496',
    },
    {
      phone: '(994) 12 436-86-21',
      formatted: '+994 12 436-86-21',
      raw: '+994124368621',
    },
    {
      phone: '(994) 12 437-18-10',
      formatted: '+994 12 437-18-10',
      raw: '+994124371810',
    },
    {
      phone: '(994) 12 440-13-00',
      formatted: '+994 12 440-13-00',
      raw: '+994124401300',
    },
    {
      phone: '(994) 12 440-39-39',
      formatted: '+994 12 440-39-39',
      raw: '+994124403939',
    },
    {
      phone: '(994) 12 440-53-21',
      formatted: '+994 12 440-53-21',
      raw: '+994124405321',
    },
    {
      phone: '(994) 12 440-80-07',
      formatted: '+994 12 440-80-07',
      raw: '+994124408007',
    },
    {
      phone: '(994) 12 440-83-23',
      formatted: '+994 12 440-83-23',
      raw: '+994124408323',
    },
    {
      phone: '(994) 12 440-90-06',
      formatted: '+994 12 440-90-06',
      raw: '+994124409006',
    },
    {
      phone: '(994) 12 447-85-55',
      formatted: '+994 12 447-85-55',
      raw: '+994124478555',
    },
    {
      phone: '(994) 12 449-51-50',
      formatted: '+994 12 449-51-50',
      raw: '+994124495150',
    },
    {
      phone: '(994) 12 449-67-57',
      formatted: '+994 12 449-67-57',
      raw: '+994124496757',
    },
    {
      phone: '(994)12 464-86-93',
      formatted: '+994 12 464-86-93',
      raw: '+994124648693',
    },
    {
      phone: '(994) 12 464-87-87',
      formatted: '+994 12 464-87-87',
      raw: '+994124648787',
    },
    {
      phone: '(994) 12 490-43-04',
      formatted: '+994 12 490-43-04',
      raw: '+994124904304',
    },
    {
      phone: '(994) 12 491-19-81',
      formatted: '+994 12 491-19-81',
      raw: '+994124911981',
    },
    {
      phone: '(994) 12 491-43-14',
      formatted: '+994 12 491-43-14',
      raw: '+994124914314',
    },
    {
      phone: '(994) 12 492-10-92',
      formatted: '+994 12 492-10-92',
      raw: '+994124921092',
    },
    {
      phone: '(994) 12 492-69-11',
      formatted: '+994 12 492-69-11',
      raw: '+994124926911',
    },
    {
      phone: '(994) 12 493-00-24',
      formatted: '+994 12 493-00-24',
      raw: '+994124930024',
    },
    {
      phone: '(994) 12 493-11-80',
      formatted: '+994 12 493-11-80',
      raw: '+994124931180',
    },
    {
      phone: '(994) 12 493-40-93',
      formatted: '+994 12 493-40-93',
      raw: '+994124934093',
    },
    {
      phone: '(994) 12 493-72-26',
      formatted: '+994 12 493-72-26',
      raw: '+994124937226',
    },
    {
      phone: '(994) 12 493-81-25',
      formatted: '+994 12 493-81-25',
      raw: '+994124938125',
    },
    {
      phone: '(994) 12 495-30-73',
      formatted: '+994 12 495-30-73',
      raw: '+994124953073',
    },
    {
      phone: '(994) 12 495-38-78',
      formatted: '+994 12 495-38-78',
      raw: '+994124953878',
    },
    {
      phone: '(994) 12 496-15-55',
      formatted: '+994 12 496-15-55',
      raw: '+994124961555',
    },
    {
      phone: '(994) 12 496-24-45',
      formatted: '+994 12 496-24-45',
      raw: '+994124962445',
    },
    {
      phone: '(994) 12 496-24-47',
      formatted: '+994 12 496-24-47',
      raw: '+994124962447',
    },
    {
      phone: '(994) 12 496-96-06',
      formatted: '+994 12 496-96-06',
      raw: '+994124969606',
    },
    {
      phone: '(994) 12 497-12-50',
      formatted: '+994 12 497-12-50',
      raw: '+994124971250',
    },
    {
      phone: '(994) 12 497-18-14',
      formatted: '+994 12 497-18-14',
      raw: '+994124971814',
    },
    {
      phone: '(994) 12 498-00-65',
      formatted: '+994 12 498-00-65',
      raw: '+994124980065',
    },
    {
      phone: '(994) 12 498-88-34',
      formatted: '+994 12 498-88-34',
      raw: '+994124988834',
    },
    {
      phone: '(994) 12 505-07-17',
      formatted: '+994 12 505-07-17',
      raw: '+994125050717',
    },
    {
      phone: '+ 994 12 505 62 31',
      formatted: '+994 12 505-62-31',
      raw: '+994125056231',
    },
    {
      phone: '(994) 12 505-99-29',
      formatted: '+994 12 505-99-29',
      raw: '+994125059929',
    },
    {
      phone: '(994) 12 514-45-01',
      formatted: '+994 12 514-45-01',
      raw: '+994125144501',
    },
    {
      phone: '(+994 12) 525 09 19',
      formatted: '+994 12 525-09-19',
      raw: '+994125250919',
    },
    {
      phone: '(994) 12 533-69-23',
      formatted: '+994 12 533-69-23',
      raw: '+994125336923',
    },
    {
      phone: '(994) 12 538-01-41',
      formatted: '+994 12 538-01-41',
      raw: '+994125380141',
    },
    {
      phone: '(994) 12 538-50-41',
      formatted: '+994 12 538-50-41',
      raw: '+994125385041',
    },
    {
      phone: '(994) 12 538-85-57',
      formatted: '+994 12 538-85-57',
      raw: '+994125388557',
    },
    {
      phone: '(994) 12 541-57-96',
      formatted: '+994 12 541-57-96',
      raw: '+994125415796',
    },
    {
      phone: '(994) 12 541-58-45',
      formatted: '+994 12 541-58-45',
      raw: '+994125415845',
    },
    {
      phone: '(994) 12 555-43-53',
      formatted: '+994 12 555-43-53',
      raw: '+994125554353',
    },
    {
      phone: '(994) 12 561-03-03',
      formatted: '+994 12 561-03-03',
      raw: '+994125610303',
    },
    {
      phone: '(994) 12 561-24-37',
      formatted: '+994 12 561-24-37',
      raw: '+994125612437',
    },
    {
      phone: '(994) 12 561-66-66',
      formatted: '+994 12 561-66-66',
      raw: '+994125616666',
    },
    {
      phone: '(994) 12 563-00-14',
      formatted: '+994 12 563-00-14',
      raw: '+994125630014',
    },
    {
      phone: '(994) 12 564-13-80',
      formatted: '+994 12 564-13-80',
      raw: '+994125641380',
    },
  ],
  BY: [
    {
      phone: '(01512) 2-10-59',
      formatted: '+375 15 122-10-59',
      raw: '+375151221059',
    },
    {
      phone: '(01512) 6-03-03',
      formatted: '+375 15 126-03-03',
      raw: '+375151260303',
    },
    {
      phone: '(0152) 39-81-42',
      formatted: '+375 15 239-81-42',
      raw: '+375152398142',
    },
    {
      phone: '(0152) 44-44-20, (0152) 44-44-10, (029) 166-48-80, (033) 351-04-70',
      formatted: '+375 33 351-04-70',
      raw: '+375333510470',
    },
    {
      phone: '(0154) 65-27-46',
      formatted: '+375 15 465-27-46',
      raw: '+375154652746',
    },
    {
      phone: '(0154) 65-82-43',
      formatted: '+375 15 465-82-43',
      raw: '+375154658243',
    },
    {
      phone: '(0154) 65-88-99',
      formatted: '+375 15 465-88-99',
      raw: '+375154658899',
    },
    {
      phone: '(01595) 6-29-07',
      formatted: '+375 15 956-29-07',
      raw: '+375159562907',
    },
    {
      phone: '(01595) 6-52-71',
      formatted: '+375 15 956-52-71',
      raw: '+375159565271',
    },
    {
      phone: '(01595) 6-76-87',
      formatted: '+375 15 956-76-87',
      raw: '+375159567687',
    },
    {
      phone: '(0162) 21-16-31',
      formatted: '+375 16 221-16-31',
      raw: '+375162211631',
    },
    {
      phone: '(0162) 24-51-86',
      formatted: '+375 16 224-51-86',
      raw: '+375162245186',
    },
    {
      phone: '(0162) 24-54-32',
      formatted: '+375 16 224-54-32',
      raw: '+375162245432',
    },
    {
      phone: '(0162) 24-90-65',
      formatted: '+375 16 224-90-65',
      raw: '+375162249065',
    },
    {
      phone: '(0162) 29-13-80, (+37529) 2349171',
      formatted: '+375 29 234-91-71',
      raw: '+375292349171',
    },
    {
      phone: '(0162) 93-31-37',
      formatted: '+375 16 293-31-37',
      raw: '+375162933137',
    },
    {
      phone: '(0162) 94-52-37',
      formatted: '+375 16 294-52-37',
      raw: '+375162945237',
    },
    {
      phone: '(0162) 95-31-95',
      formatted: '+375 16 295-31-95',
      raw: '+375162953195',
    },
    {
      phone: '(0163) 43-52-89',
      formatted: '+375 16 343-52-89',
      raw: '+375163435289',
    },
    {
      phone: '(0163) 44-62-55',
      formatted: '+375 16 344-62-55',
      raw: '+375163446255',
    },
    {
      phone: '(0163) 46-97-68, (0163) 46-97-46',
      formatted: '+375 16 346-97-46',
      raw: '+375163469746',
    },
    {
      phone: '(0163) 61-80-02',
      formatted: '+375 16 361-80-02',
      raw: '+375163618002',
    },
    {
      phone: '(0163) 64-98-00',
      formatted: '+375 16 364-98-00',
      raw: '+375163649800',
    },
    {
      phone: '(0163) 65-88-60',
      formatted: '+375 16 365-88-60',
      raw: '+375163658860',
    },
    {
      phone: '(017) 15-6-96-03',
      formatted: '+375 17 156-96-03',
      raw: '+375171569603',
    },
    {
      phone: '(017) 200-22-02',
      formatted: '+375 17 200-22-02',
      raw: '+375172002202',
    },
    {
      phone: '(017) 220-49-23, (029) 390-00-28, (029) 518-63-73',
      formatted: '+375 29 518-63-73',
      raw: '+375295186373',
    },
    {
      phone: '(017) 222-21-31, 7807',
      formatted: '+375 17 222-21-31',
      raw: '+375172222131',
    },
    {
      phone: '(017) 222-21-31, 7807, 375 (17) 222-21-31',
      formatted: '+375 17 222-21-31',
      raw: '+375172222131',
    },
    {
      phone: '(017) 222-21-3, 7807',
      formatted: '+375 01 722-22-13',
      raw: '+375017222213',
    },
    {
      phone: '(017) 227-07-07, (029) 150-07-07',
      formatted: '+375 29 150-07-07',
      raw: '+375291500707',
    },
    {
      phone: '(017) 235-86-84',
      formatted: '+375 17 235-86-84',
      raw: '+375172358684',
    },
    {
      phone: '(017) 236-7-236',
      formatted: '+375 17 236-72-36',
      raw: '+375172367236',
    },
    {
      phone: '(017) 240-30-22, (017) 240-30-23',
      formatted: '+375 17 240-30-23',
      raw: '+375172403023',
    },
    {
      phone: '(017) 243-33-98',
      formatted: '+375 17 243-33-98',
      raw: '+375172433398',
    },
    {
      phone: '(017)  243-92-86, (017)  353-83-51, (017) 352-92-84',
      formatted: '+375 17 352-92-84',
      raw: '+375173529284',
    },
    {
      phone: '(017) 270-05-79',
      formatted: '+375 17 270-05-79',
      raw: '+375172700579',
    },
    {
      phone: '(017) 270-05-79, (017) 323-24-67',
      formatted: '+375 17 323-24-67',
      raw: '+375173232467',
    },
    {
      phone: '(017) 270-40-79, (029) 371-85-40',
      formatted: '+375 29 371-85-40',
      raw: '+375293718540',
    },
    {
      phone: '(017) 270-45-93, (017) 270-45-91',
      formatted: '+375 17 270-45-91',
      raw: '+375172704591',
    },
    {
      phone: '(017) 271-02-28, (017) 378-04-62',
      formatted: '+375 17 378-04-62',
      raw: '+375173780462',
    },
    {
      phone: '(017) 275-15-33',
      formatted: '+375 17 275-15-33',
      raw: '+375172751533',
    },
    {
      phone: '(017) 276 74 26',
      formatted: '+375 17 276-74-26',
      raw: '+375172767426',
    },
    {
      phone: '(017) 278-78-07',
      formatted: '+375 17 278-78-07',
      raw: '+375172787807',
    },
    {
      phone: '(017) 278-78-07, 7807',
      formatted: '+375 17 278-78-07',
      raw: '+375172787807',
    },
    {
      phone: '(017) 279-61-33',
      formatted: '+375 17 279-61-33',
      raw: '+375172796133',
    },
    {
      phone: '(017) 303-10-93, 375 (33) 676-56-18, 375 (17) 307-93-71',
      formatted: '+375 17 307-93-71',
      raw: '+375173079371',
    },
    {
      phone: '(017) 304-33-55, (017) 352-21-73',
      formatted: '+375 17 352-21-73',
      raw: '+375173522173',
    },
    {
      phone: '(017) 310-03-03, 375 (29) 328-23-71',
      formatted: '+375 29 328-23-71',
      raw: '+375293282371',
    },
    {
      phone: '(017) 310-08-00, (029) 380-06-46',
      formatted: '+375 29 380-06-46',
      raw: '+375293800646',
    },
    {
      phone: '017-311-10-91, 017-311-10-92',
      formatted: '+375 17 311-10-92',
      raw: '+375173111092',
    },
    {
      phone: '(017) 324-83-60,  (017) 351-15-69, (017) 320-86-77',
      formatted: '+375 17 320-86-77',
      raw: '+375173208677',
    },
    {
      phone: '(017) 326-59-43, (017) 319-19-31',
      formatted: '+375 17 319-19-31',
      raw: '+375173191931',
    },
    {
      phone: '(017) 343-00-17, 375 (17) 343-00-65',
      formatted: '+375 17 343-00-65',
      raw: '+375173430065',
    },
    {
      phone: '(017) 343-22-28, (017) 355-51-34, (044) 535-96-71',
      formatted: '+375 44 535-96-71',
      raw: '+375445359671',
    },
    {
      phone: '(017) 345-48-93',
      formatted: '+375 17 345-48-93',
      raw: '+375173454893',
    },
    {
      phone: '(017) 351-61-74',
      formatted: '+375 17 351-61-74',
      raw: '+375173516174',
    },
    {
      phone: '(017) 353-99-38, (029) 656-98-23',
      formatted: '+375 29 656-98-23',
      raw: '+375296569823',
    },
    {
      phone: '(017) 355-23-99',
      formatted: '+375 17 355-23-99',
      raw: '+375173552399',
    },
    {
      phone: '(017) 356-06-08',
      formatted: '+375 17 356-06-08',
      raw: '+375173560608',
    },
    {
      phone: '(017) 361-46-74',
      formatted: '+375 17 361-46-74',
      raw: '+375173614674',
    },
    {
      phone: '(017) 363 15-86',
      formatted: '+375 17 363-15-86',
      raw: '+375173631586',
    },
    {
      phone: '(017) 364-37-44',
      formatted: '+375 17 364-37-44',
      raw: '+375173643744',
    },
    {
      phone: '(017) 365-14-42, (017) 363-07-74',
      formatted: '+375 17 363-07-74',
      raw: '+375173630774',
    },
    {
      phone: '(017) 365-37-04',
      formatted: '+375 17 365-37-04',
      raw: '+375173653704',
    },
    {
      phone: '(017) 368-37-63',
      formatted: '+375 17 368-37-63',
      raw: '+375173683763',
    },
    {
      phone: '(017) 368-37-63, (044) 586-58-95',
      formatted: '+375 44 586-58-95',
      raw: '+375445865895',
    },
    {
      phone: '(017) 369-03-33',
      formatted: '+375 17 369-03-33',
      raw: '+375173690333',
    },
    {
      phone: '(017) 371-00-21',
      formatted: '+375 17 371-00-21',
      raw: '+375173710021',
    },
    {
      phone: '(017) 373-33-45, (017) 322-05-78',
      formatted: '+375 17 322-05-78',
      raw: '+375173220578',
    },
    {
      phone: '(017) 373-40-00',
      formatted: '+375 17 373-40-00',
      raw: '+375173734000',
    },
    {
      phone: '(017) 37-35-888, (017) 37-34-888, (029) 634-53-59, (029) 852-16-70',
      formatted: '+375 29 852-16-70',
      raw: '+375298521670',
    },
    {
      phone: '(017) 373 60 86',
      formatted: '+375 17 373-60-86',
      raw: '+375173736086',
    },
    {
      phone: '(017) 375-12-69, (017) 342-09-57',
      formatted: '+375 17 342-09-57',
      raw: '+375173420957',
    },
    {
      phone: '(017) 378-16-30',
      formatted: '+375 17 378-16-30',
      raw: '+375173781630',
    },
    {
      phone: '(017) 378-33-35, (017) 378-33-38, (029) 303-65-11,  (029) 263-95-03',
      formatted: '+375 29 263-95-03',
      raw: '+375292639503',
    },
    {
      phone: '(017)  378-55-06',
      formatted: '+375 17 378-55-06',
      raw: '+375173785506',
    },
    {
      phone: '(017) 378-61-71',
      formatted: '+375 17 378-61-71',
      raw: '+375173786171',
    },
    {
      phone: '(017) 378-65-28, (017) 379-85-65',
      formatted: '+375 17 379-85-65',
      raw: '+375173798565',
    },
    {
      phone: '(017) 379-02-86, (017) 263-02-87',
      formatted: '+375 17 263-02-87',
      raw: '+375172630287',
    },
    {
      phone: '(017) 379-12-36, (017) 378-18-82',
      formatted: '+375 17 378-18-82',
      raw: '+375173781882',
    },
    {
      phone: '(017) 379-55-77, (044) 553-38-13',
      formatted: '+375 44 553-38-13',
      raw: '+375445533813',
    },
    {
      phone: '017 379-81-02',
      formatted: '+375 17 379-81-02',
      raw: '+375173798102',
    },
    {
      phone: '(017) 379-85-65, (017) 354-25-08, (375 44) 570-08-59',
      formatted: '+375 44 570-08-59',
      raw: '+375445700859',
    },
    {
      phone: '(017) 388-49-50, (017) 388-49-51, (029) 339-43-10, (033) 371-86-11',
      formatted: '+375 33 371-86-11',
      raw: '+375333718611',
    },
    {
      phone: '(017) 390-06-42, (017)-373-20-84',
      formatted: '+375 17 373-20-84',
      raw: '+375173732084',
    },
    {
      phone: '(017) 393-30-64, (017) 393-30-65, (044) 535-19-41, (033) 664-77-52',
      formatted: '+375 33 664-77-52',
      raw: '+375336647752',
    },
    {
      phone: '(017) 395-69-25, (017) 395-69-35, (017) 397-69-28',
      formatted: '+375 17 397-69-28',
      raw: '+375173976928',
    },
    {
      phone: '(017) 395-94-21',
      formatted: '+375 17 395-94-21',
      raw: '+375173959421',
    },
    {
      phone: '(017) 397-20-98',
      formatted: '+375 17 397-20-98',
      raw: '+375173972098',
    },
    {
      phone: '(017) 397-88-87, (025) 9-103-103',
      formatted: '+375 25 910-31-03',
      raw: '+375259103103',
    },
    {
      phone: '(017) 399-24-07',
      formatted: '+375 17 399-24-07',
      raw: '+375173992407',
    },
    {
      phone: '(017) 399-67-56',
      formatted: '+375 17 399-67-56',
      raw: '+375173996756',
    },
    {
      phone: '(017) 509-75-62',
      formatted: '+375 17 509-75-62',
      raw: '+375175097562',
    },
    {
      phone: '(017) 544-91-03, (017) 544-90-98',
      formatted: '+375 17 544-90-98',
      raw: '+375175449098',
    },
    {
      phone: '(0176) 52-82-63',
      formatted: '+375 17 652-82-63',
      raw: '+375176528263',
    },
    {
      phone: '(0176) 58-05-87',
      formatted: '+375 17 658-05-87',
      raw: '+375176580587',
    },
    {
      phone: '(0176) 58-10-51',
      formatted: '+375 17 658-10-51',
      raw: '+375176581051',
    },
    {
      phone: '(0176) 58-14-23, (0291) 28-30-44',
      formatted: '+375 29 128-30-44',
      raw: '+375291283044',
    },
    {
      phone: '(0176) 58-15-98',
      formatted: '+375 17 658-15-98',
      raw: '+375176581598',
    },
  ],
  GE: [
    {
      phone: '032 243 33 43',
      formatted: '+995 322 43-33-43',
      raw: '+995322433343',
    },
    {
      phone: '(032) 2 47 06 06',
      formatted: '+995 322 47-06-06',
      raw: '+995322470606',
    },
    {
      phone: '(032) 255-05-05',
      formatted: '+995 322 55-05-05',
      raw: '+995322550505',
    },
    {
      phone: '(0422) 22-71-71',
      formatted: '+995 422 22-71-71',
      raw: '+995422227171',
    },
    {
      phone: '0422 22 88 22',
      formatted: '+995 422 22-88-22',
      raw: '+995422228822',
    },
    {
      phone: '(0422) 40-00-00',
      formatted: '+995 422 40-00-00',
      raw: '+995422400000',
    },
    {
      phone: '2 95 77 44; 2 95 46 43; 2 95 06 26',
      formatted: '2 95 77 44; 2 95 46 43; 2 95 06 26',
      raw: '2950626',
    },
    {
      phone: '(322) 29-06-71',
      formatted: '+995 322 29-06-71',
      raw: '+995322290671',
    },
    {
      phone: '(32) 255-05-05',
      formatted: '+995 322 55-05-05',
      raw: '+995322550505',
    },
    {
      phone: '(322) 93-10-00',
      formatted: '+995 322 93-10-00',
      raw: '+995322931000',
    },
    {
      phone: '(422) 21-33-33',
      formatted: '+995 422 21-33-33',
      raw: '+995422213333',
    },
    {
      phone: '(422) 25-85-13',
      formatted: '+995 422 25-85-13',
      raw: '+995422258513',
    },
    {
      phone: '(422) 27-25-88',
      formatted: '+995 422 27-25-88',
      raw: '+995422272588',
    },
    {
      phone: '(422) 27-73-03',
      formatted: '+995 422 27-73-03',
      raw: '+995422277303',
    },
    {
      phone: '(422) 29-42-37',
      formatted: '+995 422 29-42-37',
      raw: '+995422294237',
    },
    {
      phone: '(555) 28-51-08',
      formatted: '+995 555 28-51-08',
      raw: '+995555285108',
    },
    {
      phone: '(568) 08-08-63',
      formatted: '+995 568 08-08-63',
      raw: '+995568080863',
    },
    {
      phone: '(568) 12-04-04',
      formatted: '+995 568 12-04-04',
      raw: '+995568120404',
    },
    {
      phone: '(574) 11-23-33',
      formatted: '+995 574 11-23-33',
      raw: '+995574112333',
    },
    {
      phone: '(577) 20-00-22',
      formatted: '+995 577 20-00-22',
      raw: '+995577200022',
    },
    {
      phone: '(577) 44-40-55',
      formatted: '+995 577 44-40-55',
      raw: '+995577444055',
    },
    {
      phone: '(577) 55-51-80',
      formatted: '+995 577 55-51-80',
      raw: '+995577555180',
    },
    {
      phone: '(577) 77-97-97',
      formatted: '+995 577 77-97-97',
      raw: '+995577779797',
    },
    {
      phone: '(591) 05-05-95',
      formatted: '+995 591 05-05-95',
      raw: '+995591050595',
    },
    {
      phone: '(591) 07-05-05',
      formatted: '+995 591 07-05-05',
      raw: '+995591070505',
    },
    {
      phone: '(591) 40-90-90',
      formatted: '+995 591 40-90-90',
      raw: '+995591409090',
    },
    {
      phone: '591 96 77 88',
      formatted: '+995 591 96-77-88',
      raw: '+995591967788',
    },
    {
      phone: '(592) 19-26-36',
      formatted: '+995 592 19-26-36',
      raw: '+995592192636',
    },
    {
      phone: '(593) 50-93-57',
      formatted: '+995 593 50-93-57',
      raw: '+995593509357',
    },
    {
      phone: '(595) 44-11-44',
      formatted: '+995 595 44-11-44',
      raw: '+995595441144',
    },
    {
      phone: '(599) 35-02-35',
      formatted: '+995 599 35-02-35',
      raw: '+995599350235',
    },
    {
      phone: '(955) 32 242-42-52',
      formatted: '+995 322 42-42-52',
      raw: '+995322424252',
    },
    {
      phone: '(955) 577 48-11-69',
      formatted: '+995 577 48-11-69',
      raw: '+995577481169',
    },
    {
      phone: '+995032 2 11 20 20',
      formatted: '+995 322 11-20-20',
      raw: '+995322112020',
    },
    {
      phone: '(995) 032 218-02-80',
      formatted: '+995 322 18-02-80',
      raw: '+995322180280',
    },
    {
      phone: '(+995 032) 2953311',
      formatted: '+995 322 95-33-11',
      raw: '+995322953311',
    },
    {
      phone: '(995) 32 200-11-01',
      formatted: '+995 322 00-11-01',
      raw: '+995322001101',
    },
    {
      phone: '(995) 322 00-90-00',
      formatted: '+995 322 00-90-00',
      raw: '+995322009000',
    },
    {
      phone: '(995) 322 00-90-09',
      formatted: '+995 322 00-90-09',
      raw: '+995322009009',
    },
    {
      phone: '(995) 322 01-13-30',
      formatted: '+995 322 01-13-30',
      raw: '+995322011330',
    },
    {
      phone: '(995) 32 205-11-11',
      formatted: '+995 322 05-11-11',
      raw: '+995322051111',
    },
    {
      phone: '(995) 322 05-11-11',
      formatted: '+995 322 05-11-11',
      raw: '+995322051111',
    },
    {
      phone: '(995) 32 205-20-70',
      formatted: '+995 322 05-20-70',
      raw: '+995322052070',
    },
    {
      phone: '(995) 322 10-11-00',
      formatted: '+995 322 10-11-00',
      raw: '+995322101100',
    },
    {
      phone: '(995) 322 10-48-10',
      formatted: '+995 322 10-48-10',
      raw: '+995322104810',
    },
    {
      phone: '(995) 322 10-91-08',
      formatted: '+995 322 10-91-08',
      raw: '+995322109108',
    },
    {
      phone: '(995) 322 11-00-30',
      formatted: '+995 322 11-00-30',
      raw: '+995322110030',
    },
    {
      phone: '(995) 322 11-11-12',
      formatted: '+995 322 11-11-12',
      raw: '+995322111112',
    },
    {
      phone: '(995) 32 211-17-00',
      formatted: '+995 322 11-17-00',
      raw: '+995322111700',
    },
    {
      phone: '(995) 322 11-17-00',
      formatted: '+995 322 11-17-00',
      raw: '+995322111700',
    },
    {
      phone: '(995) 322 11-22-26',
      formatted: '+995 322 11-22-26',
      raw: '+995322112226',
    },
    {
      phone: '(995) 322 11-46-93',
      formatted: '+995 322 11-46-93',
      raw: '+995322114693',
    },
    {
      phone: '(995) 322 12-11-22',
      formatted: '+995 322 12-11-22',
      raw: '+995322121122',
    },
    {
      phone: '(995) 322 12-20-02',
      formatted: '+995 322 12-20-02',
      raw: '+995322122002',
    },
    {
      phone: '(995) 322 12-25-25',
      formatted: '+995 322 12-25-25',
      raw: '+995322122525',
    },
    {
      phone: '(995) 322 14-14-10',
      formatted: '+995 322 14-14-10',
      raw: '+995322141410',
    },
    {
      phone: '(995) 322 14-15-15',
      formatted: '+995 322 14-15-15',
      raw: '+995322141515',
    },
    {
      phone: '(995) 32-214-18-14',
      formatted: '+995 322 14-18-14',
      raw: '+995322141814',
    },
    {
      phone: '(995) 322 14-26-09',
      formatted: '+995 322 14-26-09',
      raw: '+995322142609',
    },
    {
      phone: '(995) 322 14-33-97',
      formatted: '+995 322 14-33-97',
      raw: '+995322143397',
    },
    {
      phone: '(995) 322 14-45-45',
      formatted: '+995 322 14-45-45',
      raw: '+995322144545',
    },
    {
      phone: '(995) 322 14-71-72',
      formatted: '+995 322 14-71-72',
      raw: '+995322147172',
    },
    {
      phone: '(995) 322 15-13-11',
      formatted: '+995 322 15-13-11',
      raw: '+995322151311',
    },
    {
      phone: '(995) 32-218-02-03',
      formatted: '+995 322 18-02-03',
      raw: '+995322180203',
    },
    {
      phone: '(995) 322 18-02-80',
      formatted: '+995 322 18-02-80',
      raw: '+995322180280',
    },
    {
      phone: '(995) 322 18-10-04',
      formatted: '+995 322 18-10-04',
      raw: '+995322181004',
    },
    {
      phone: '+995 32 2 18 18 14',
      formatted: '+995 322 18-18-14',
      raw: '+995322181814',
    },
    {
      phone: '(995) 32-218-24-34',
      formatted: '+995 322 18-24-34',
      raw: '+995322182434',
    },
    {
      phone: '(995) 322 18-33-18',
      formatted: '+995 322 18-33-18',
      raw: '+995322183318',
    },
    {
      phone: '(995) 322 18-56-76',
      formatted: '+995 322 18-56-76',
      raw: '+995322185676',
    },
    {
      phone: '+995 322 190 190',
      formatted: '+995 322 19-01-90',
      raw: '+995322190190',
    },
    {
      phone: '(995) 322 20-13-20',
      formatted: '+995 322 20-13-20',
      raw: '+995322201320',
    },
    {
      phone: '(995) 32-222-15-16',
      formatted: '+995 322 22-15-16',
      raw: '+995322221516',
    },
    {
      phone: '(995) 322 22-19-43',
      formatted: '+995 322 22-19-43',
      raw: '+995322221943',
    },
    {
      phone: '(995) 32-222-21-22',
      formatted: '+995 322 22-21-22',
      raw: '+995322222122',
    },
    {
      phone: '+995 32 222 24 42',
      formatted: '+995 322 22-24-42',
      raw: '+995322222442',
    },
    {
      phone: '(995) 322 22-32-23',
      formatted: '+995 322 22-32-23',
      raw: '+995322223223',
    },
    {
      phone: '(995) 322 22-56-17',
      formatted: '+995 322 22-56-17',
      raw: '+995322225617',
    },
    {
      phone: '(995) 322 22-67-22',
      formatted: '+995 322 22-67-22',
      raw: '+995322226722',
    },
    {
      phone: '(995) 322 23-04-04',
      formatted: '+995 322 23-04-04',
      raw: '+995322230404',
    },
    {
      phone: '+995 322 232 232',
      formatted: '+995 322 23-22-32',
      raw: '+995322232232',
    },
    {
      phone: '(995) 322 23-40-23',
      formatted: '+995 322 23-40-23',
      raw: '+995322234023',
    },
    {
      phone: '(995) 322-23-63-21',
      formatted: '+995 322 23-63-21',
      raw: '+995322236321',
    },
    {
      phone: '(995) 322 23-84-80',
      formatted: '+995 322 23-84-80',
      raw: '+995322238480',
    },
    {
      phone: '(995) 322 24-21-24',
      formatted: '+995 322 24-21-24',
      raw: '+995322242124',
    },
    {
      phone: '+995 32 2 24 32 32',
      formatted: '+995 322 24-32-32',
      raw: '+995322243232',
    },
    {
      phone: '(995) 322 24-44-55',
      formatted: '+995 322 24-44-55',
      raw: '+995322244455',
    },
    {
      phone: '+995 322 25 19 91',
      formatted: '+995 322 25-19-91',
      raw: '+995322251991',
    },
    {
      phone: '(995) 322 25-82-85',
      formatted: '+995 322 25-82-85',
      raw: '+995322258285',
    },
    {
      phone: '(995) 32 229-06-71',
      formatted: '+995 322 29-06-71',
      raw: '+995322290671',
    },
    {
      phone: '(99532) 229-06-71',
      formatted: '+995 322 29-06-71',
      raw: '+995322290671',
    },
    {
      phone: '(995) 322 30-26-49',
      formatted: '+995 322 30-26-49',
      raw: '+995322302649',
    },
    {
      phone: '(995) 322 30-60-66',
      formatted: '+995 322 30-60-66',
      raw: '+995322306066',
    },
    {
      phone: '(995) 32-230-88-92',
      formatted: '+995 322 30-88-92',
      raw: '+995322308892',
    },
    {
      phone: '(995) 322 32-22-27',
      formatted: '+995 322 32-22-27',
      raw: '+995322322227',
    },
    {
      phone: '(995) 322 32-31-03',
      formatted: '+995 322 32-31-03',
      raw: '+995322323103',
    },
    {
      phone: '(995) 32 233-08-33',
      formatted: '+995 322 33-08-33',
      raw: '+995322330833',
    },
    {
      phone: '(995) 322 33-20-24',
      formatted: '+995 322 33-20-24',
      raw: '+995322332024',
    },
    {
      phone: '(995) 322 34-40-97',
      formatted: '+995 322 34-40-97',
      raw: '+995322344097',
    },
    {
      phone: '(995) 32-236-01-28',
      formatted: '+995 322 36-01-28',
      raw: '+995322360128',
    },
  ],
  KG: [
    {
      phone: '0 (312) 25-03-56',
      formatted: '+996 312 250-356',
      raw: '+996312250356',
    },
    {
      phone: '0 (312) 31-25-24',
      formatted: '+996 312 312-524',
      raw: '+996312312524',
    },
    {
      phone: '0 (312) 32-03-03',
      formatted: '+996 312 320-303',
      raw: '+996312320303',
    },
    {
      phone: '0312 431 333',
      formatted: '+996 312 431-333',
      raw: '+996312431333',
    },
    {
      phone: '0312 43 97 97',
      formatted: '+996 312 439-797',
      raw: '+996312439797',
    },
    {
      phone: '0 (312) 54–00–10',
      formatted: '+996 312 540-010',
      raw: '+996312540010',
    },
    {
      phone: '0 (312) 54-11-19, 996 (500) 54-11-19',
      formatted: '+996 500 541-119',
      raw: '+996500541119',
    },
    {
      phone: '0312 54 56 30',
      formatted: '+996 312 545-630',
      raw: '+996312545630',
    },
    {
      phone: '0 (312) 54-79-97, 0 (770) 54-77-97',
      formatted: '+996 770 547-797',
      raw: '+996770547797',
    },
    {
      phone: '0 (312) 65-18-15',
      formatted: '+996 312 651-815',
      raw: '+996312651815',
    },
    {
      phone: '0 (312) 903 433',
      formatted: '+996 312 903-433',
      raw: '+996312903433',
    },
    {
      phone: '0 (312) 90-82-70',
      formatted: '+996 312 908-270',
      raw: '+996312908270',
    },
    {
      phone: '0 (312) 90-90-09',
      formatted: '+996 312 909-009',
      raw: '+996312909009',
    },
    {
      phone: '0 (312) 91-13-03, 0 (555) 91-13-03',
      formatted: '+996 555 911-303',
      raw: '+996555911303',
    },
    {
      phone: '0 312 975 115',
      formatted: '+996 312 975-115',
      raw: '+996312975115',
    },
    {
      phone: '0 (312) 98-66-00',
      formatted: '+996 312 986-600',
      raw: '+996312986600',
    },
    {
      phone: '0 (3722) 2-21-88',
      formatted: '+996 372 222-188',
      raw: '+996372222188',
    },
    {
      phone: '0 (3722) 23 999',
      formatted: '+996 372 223-999',
      raw: '+996372223999',
    },
    {
      phone: '0 (392) 25-03-80, 0 (508) 42-33-22',
      formatted: '+996 508 423-322',
      raw: '+996508423322',
    },
    {
      phone: '0 (500) 66-48-02',
      formatted: '+996 500 664-802',
      raw: '+996500664802',
    },
    {
      phone: '0 (501) 88-06-88',
      formatted: '+996 501 880-688',
      raw: '+996501880688',
    },
    {
      phone: '0 (502) 62-62-33',
      formatted: '+996 502 626-233',
      raw: '+996502626233',
    },
    {
      phone: '0 (504) 44-40-17',
      formatted: '+996 504 444-017',
      raw: '+996504444017',
    },
    {
      phone: '0 (504) 44-40-19',
      formatted: '+996 504 444-019',
      raw: '+996504444019',
    },
    {
      phone: '0 (504) 44-40-24',
      formatted: '+996 504 444-024',
      raw: '+996504444024',
    },
    {
      phone: '0 (504) 44-40-25',
      formatted: '+996 504 444-025',
      raw: '+996504444025',
    },
    {
      phone: '0 (504) 44-40-26, 0 (504) 44-40-89',
      formatted: '+996 504 444-089',
      raw: '+996504444089',
    },
    {
      phone: '0 (504) 44-40-59',
      formatted: '+996 504 444-059',
      raw: '+996504444059',
    },
    {
      phone: '0 (504) 44-40-62',
      formatted: '+996 504 444-062',
      raw: '+996504444062',
    },
    {
      phone: '(0504) 44-41-07',
      formatted: '+996 504 444-107',
      raw: '+996504444107',
    },
    {
      phone: '0 (507) 30-32-03',
      formatted: '+996 507 303-203',
      raw: '+996507303203',
    },
    {
      phone: '0 (550) 23-01-01',
      formatted: '+996 550 230-101',
      raw: '+996550230101',
    },
    {
      phone: '0 (550) 35-40-04',
      formatted: '+996 550 354-004',
      raw: '+996550354004',
    },
    {
      phone: '0 (550) 50-88-99',
      formatted: '+996 550 508-899',
      raw: '+996550508899',
    },
    {
      phone: '0 (550) 55-68-78',
      formatted: '+996 550 556-878',
      raw: '+996550556878',
    },
    {
      phone: '0 (550) 881181',
      formatted: '+996 550 881-181',
      raw: '+996550881181',
    },
    {
      phone: '0 (551) 16-66-88, 0 (700) 58-23-67',
      formatted: '+996 700 582-367',
      raw: '+996700582367',
    },
    {
      phone: '0 (551) 46-81-11, 0 (312) 46-81-11, 0 (312) 46-01-11',
      formatted: '+996 312 460-111',
      raw: '+996312460111',
    },
    {
      phone: '0 (551) 89-18-28, 0 (706) 88-18-28',
      formatted: '+996 706 881-828',
      raw: '+996706881828',
    },
    {
      phone: '0 (552) 19-99-29',
      formatted: '+996 552 199-929',
      raw: '+996552199929',
    },
    {
      phone: '0 (552) 75-55-55, 0 (700) 75-55-55',
      formatted: '+996 700 755-555',
      raw: '+996700755555',
    },
    {
      phone: '0 (553) 04-34-43, 0 (501) 04-34-43',
      formatted: '+996 501 043-443',
      raw: '+996501043443',
    },
    {
      phone: '0553 43 97 57',
      formatted: '+996 553 439-757',
      raw: '+996553439757',
    },
    {
      phone: '0 (554) 33-99-83',
      formatted: '+996 554 339-983',
      raw: '+996554339983',
    },
    {
      phone: '0 (555) 06-46-46',
      formatted: '+996 555 064-646',
      raw: '+996555064646',
    },
    {
      phone: '0555 09 04 09',
      formatted: '+996 555 090-409',
      raw: '+996555090409',
    },
    {
      phone: '0 (555) 10–35–22',
      formatted: '+996 555 103-522',
      raw: '+996555103522',
    },
    {
      phone: '0(555) 34 19 24',
      formatted: '+996 555 341-924',
      raw: '+996555341924',
    },
    {
      phone: '0 (555) 53-00-49',
      formatted: '+996 555 530-049',
      raw: '+996555530049',
    },
    {
      phone: '0555 55 22 33 / 1333',
      formatted: '+996 555 552-233',
      raw: '+996555552233',
    },
    {
      phone: '0 (555) 56-50-52',
      formatted: '+996 555 565-052',
      raw: '+996555565052',
    },
    {
      phone: '0 (555) 81-29-10',
      formatted: '+996 555 812-910',
      raw: '+996555812910',
    },
    {
      phone: '0 (556) 33-33-33, 0 (553) 66-66-66, 0 (705) 85-00-13',
      formatted: '+996 705 850-013',
      raw: '+996705850013',
    },
    {
      phone: '0557 10 30 40',
      formatted: '+996 557 103-040',
      raw: '+996557103040',
    },
    {
      phone: '0 (557) 22-94-22',
      formatted: '+996 557 229-422',
      raw: '+996557229422',
    },
    {
      phone: '0 (559) 38-38-33, 0 (709) 38-38-33',
      formatted: '+996 709 383-833',
      raw: '+996709383833',
    },
    {
      phone: '0 (700) 50-41-96, 0 (220) 13-06-08',
      formatted: '+996 220 130-608',
      raw: '+996220130608',
    },
    {
      phone: '0 (703) 15-02-66, 0 (312) 37-52-16',
      formatted: '+996 312 375-216',
      raw: '+996312375216',
    },
    {
      phone: '(070) 339-44-00',
      formatted: '+996 703 394-400',
      raw: '+996703394400',
    },
    {
      phone: '0 (703) 63-68-63, 0 (702) 38-95-40',
      formatted: '+996 702 389-540',
      raw: '+996702389540',
    },
    {
      phone: '0 (704) 46-09-09',
      formatted: '+996 704 460-909',
      raw: '+996704460909',
    },
    {
      phone: '0 (705) 35-17-80, 0 (777) 35-17-80',
      formatted: '+996 777 351-780',
      raw: '+996777351780',
    },
    {
      phone: '0 (707) 90-90-01',
      formatted: '+996 707 909-001',
      raw: '+996707909001',
    },
    {
      phone: '0770 96 95 66',
      formatted: '+996 770 969-566',
      raw: '+996770969566',
    },
    {
      phone: '0 (777) 22-22-55',
      formatted: '+996 777 222-255',
      raw: '+996777222255',
    },
    {
      phone: '0778 31 24 52',
      formatted: '+996 778 312-452',
      raw: '+996778312452',
    },
    {
      phone: '0 (778) 58-98-07',
      formatted: '+996 778 589-807',
      raw: '+996778589807',
    },
    {
      phone: '0 (800) 111-88-88',
      formatted: '+996 001 118-888',
      raw: '+996001118888',
    },
    {
      phone: '0990 143 143, 0770 143 143',
      formatted: '+996 770 143-143',
      raw: '+996770143143',
    },
    {
      phone: '0 (990) 19-88-00, 0 (778) 19-88-00',
      formatted: '+996 778 198-800',
      raw: '+996778198800',
    },
    {
      phone: '0 (995) 50-88-99',
      formatted: '+996 995 508-899',
      raw: '+996995508899',
    },
    {
      phone: '112 / 103',
      formatted: '112 / 103',
      raw: '103',
    },
    {
      phone: '(22) 214-11-00',
      formatted: '+996 222 141-100',
      raw: '+996222141100',
    },
    {
      phone: '(225) 17‒07‒81',
      formatted: '+996 225 170-781',
      raw: '+996225170781',
    },
    {
      phone: '(312) 30‒35‒06',
      formatted: '+996 312 303-506',
      raw: '+996312303506',
    },
    {
      phone: '312 43-93-13',
      formatted: '+996 312 439-313',
      raw: '+996312439313',
    },
    {
      phone: '(312) 46-13-63',
      formatted: '+996 312 461-363',
      raw: '+996312461363',
    },
    {
      phone: '(312) 51-01-37',
      formatted: '+996 312 510-137',
      raw: '+996312510137',
    },
    {
      phone: '(312) 98‒66‒00',
      formatted: '+996 312 986-600',
      raw: '+996312986600',
    },
    {
      phone: '(3722) 5‒60‒59, (3722) 5‒54‒47',
      formatted: '+996 372 255-447',
      raw: '+996372255447',
    },
    {
      phone: '(3944) 5‒03‒08',
      formatted: '+996 394 450-308',
      raw: '+996394450308',
    },
    {
      phone: '(505) 90‒90‒09, (312) 90‒90‒09, (504) 44‒40‒28',
      formatted: '+996 504 444-028',
      raw: '+996504444028',
    },
    {
      phone: '(505) 99‒05‒09',
      formatted: '+996 505 990-509',
      raw: '+996505990509',
    },
    {
      phone: '(508) 00‒57‒50',
      formatted: '+996 508 005-750',
      raw: '+996508005750',
    },
    {
      phone: '(551) 23‒43‒93, (771) 94‒20‒24',
      formatted: '+996 771 942-024',
      raw: '+996771942024',
    },
    {
      phone: '(555) 10‒22‒16',
      formatted: '+996 555 102-216',
      raw: '+996555102216',
    },
    {
      phone: '(556) 01‒41‒14',
      formatted: '+996 556 014-114',
      raw: '+996556014114',
    },
    {
      phone: '(701) 03‒38‒91',
      formatted: '+996 701 033-891',
      raw: '+996701033891',
    },
    {
      phone: '(702) 40‒31‒03',
      formatted: '+996 702 403-103',
      raw: '+996702403103',
    },
    {
      phone: '(708) 16-51-65',
      formatted: '+996 708 165-165',
      raw: '+996708165165',
    },
    {
      phone: '(770) 11‒55‒77',
      formatted: '+996 770 115-577',
      raw: '+996770115577',
    },
    {
      phone: '(770) 33‒00‒11, (773) 08-57-12',
      formatted: '+996 773 085-712',
      raw: '+996773085712',
    },
    {
      phone: '(772) 21‒49‒23, (553) 70‒73‒48, (772) 01‒16‒16',
      formatted: '+996 772 011-616',
      raw: '+996772011616',
    },
    {
      phone: '(777) 88-55-88',
      formatted: '+996 777 885-588',
      raw: '+996777885588',
    },
    {
      phone: '(967) 77 20-17-88',
      formatted: '+996 777 201-788',
      raw: '+996777201788',
    },
    {
      phone: '(992) 553024048',
      formatted: '+996 553 024-048',
      raw: '+996553024048',
    },
    {
      phone: '+996/0 (312) 21-99-96',
      formatted: '+996 312 219-996',
      raw: '+996312219996',
    },
    {
      phone: '+996 0312 54-22-19',
      formatted: '+996 312 542-219',
      raw: '+996312542219',
    },
    {
      phone: '(996) 0312 98-66-00',
      formatted: '+996 312 986-600',
      raw: '+996312986600',
    },
    {
      phone: '996-03222-5-69-48, 996-772-047-272, 996-554-367-272',
      formatted: '+996 322 256-948',
      raw: '+996322256948',
    },
  ],
  KZ: [
    {
      phone: '(07) 847-66-55',
      formatted: '(07) 847-66-55',
      raw: '078476655',
    },
    {
      phone: '109, (778) 003-71-45',
      formatted: '+7 778 003-71-45',
      raw: '+77780037145',
    },
    {
      phone: '(162) 264-750',
      formatted: '(162) 264-750',
      raw: '162264750',
    },
    {
      phone: '20-33-14, 20-33-16',
      formatted: '20-33-14, 20-33-16',
      raw: '203316',
    },
    {
      phone: '264-22-77, 264-15-78',
      formatted: '264-22-77, 264-15-78',
      raw: '2641578',
    },
    {
      phone: '28-41-62, 28-00-62, (8778) 263-38-01',
      formatted: '+7 778 263-38-01',
      raw: '+77782633801',
    },
    {
      phone: '(474) 212-50-07, (7172) 70-50-14',
      formatted: '+7 717 270-50-14',
      raw: '+77172705014',
    },
    {
      phone: '(700) 020-12-12',
      formatted: '+7 700 020-12-12',
      raw: '+77000201212',
    },
    {
      phone: '(700) 020-55-99',
      formatted: '+7 700 020-55-99',
      raw: '+77000205599',
    },
    {
      phone: '(700) 022-09-09',
      formatted: '+7 700 022-09-09',
      raw: '+77000220909',
    },
    {
      phone: '(700) 024-05-55',
      formatted: '+7 700 024-05-55',
      raw: '+77000240555',
    },
    {
      phone: '(700) 027‒28‒29',
      formatted: '+7 700 027-28-29',
      raw: '+77000272829',
    },
    {
      phone: '(700) 035-45-45',
      formatted: '+7 700 035-45-45',
      raw: '+77000354545',
    },
    {
      phone: '(700) 03-67-333',
      formatted: '+7 700 036-73-33',
      raw: '+77000367333',
    },
    {
      phone: '(700) 036-73-33',
      formatted: '+7 700 036-73-33',
      raw: '+77000367333',
    },
    {
      phone: '(700) 040-72-72',
      formatted: '+7 700 040-72-72',
      raw: '+77000407272',
    },
    {
      phone: '(700) 047‒56‒96',
      formatted: '+7 700 047-56-96',
      raw: '+77000475696',
    },
    {
      phone: '(700) 050-00-25',
      formatted: '+7 700 050-00-25',
      raw: '+77000500025',
    },
    {
      phone: '(700) 050‒88‒08',
      formatted: '+7 700 050-88-08',
      raw: '+77000508808',
    },
    {
      phone: '(700) 057-76-77',
      formatted: '+7 700 057-76-77',
      raw: '+77000577677',
    },
    {
      phone: '(700) 086-00-03',
      formatted: '+7 700 086-00-03',
      raw: '+77000860003',
    },
    {
      phone: '(700) 086-44-44',
      formatted: '+7 700 086-44-44',
      raw: '+77000864444',
    },
    {
      phone: '(700) 089-72-72',
      formatted: '+7 700 089-72-72',
      raw: '+77000897272',
    },
    {
      phone: '(700) 090-66-36',
      formatted: '+7 700 090-66-36',
      raw: '+77000906636',
    },
    {
      phone: '(700) 093-03-23',
      formatted: '+7 700 093-03-23',
      raw: '+77000930323',
    },
    {
      phone: '(700) 094-57-00',
      formatted: '+7 700 094-57-00',
      raw: '+77000945700',
    },
    {
      phone: '(700) 097-32-32',
      formatted: '+7 700 097-32-32',
      raw: '+77000973232',
    },
    {
      phone: '(700) 100‒05‒78',
      formatted: '+7 700 100-05-78',
      raw: '+77001000578',
    },
    {
      phone: '(700) 100-54-40',
      formatted: '+7 700 100-54-40',
      raw: '+77001005440',
    },
    {
      phone: '(700) 100-70-31',
      formatted: '+7 700 100-70-31',
      raw: '+77001007031',
    },
    {
      phone: '(700) 101-70-38',
      formatted: '+7 700 101-70-38',
      raw: '+77001017038',
    },
    {
      phone: '(700) 107-45-07',
      formatted: '+7 700 107-45-07',
      raw: '+77001074507',
    },
    {
      phone: '(700) 111‒81‒81, (707) 101‒19‒18',
      formatted: '+7 707 101-19-18',
      raw: '+77071011918',
    },
    {
      phone: '(700) 116-11-22',
      formatted: '+7 700 116-11-22',
      raw: '+77001161122',
    },
    {
      phone: '(700) 116-25-25',
      formatted: '+7 700 116-25-25',
      raw: '+77001162525',
    },
    {
      phone: '(700) 123-87-00',
      formatted: '+7 700 123-87-00',
      raw: '+77001238700',
    },
    {
      phone: '(700) 125-55-18',
      formatted: '+7 700 125-55-18',
      raw: '+77001255518',
    },
    {
      phone: '(70013) 5-77-77',
      formatted: '+7 700 135-77-77',
      raw: '+77001357777',
    },
    {
      phone: '(700) 137-70-70',
      formatted: '+7 700 137-70-70',
      raw: '+77001377070',
    },
    {
      phone: '(70014) 9-95-55',
      formatted: '+7 700 149-95-55',
      raw: '+77001499555',
    },
    {
      phone: '(700) 150-11-98',
      formatted: '+7 700 150-11-98',
      raw: '+77001501198',
    },
    {
      phone: '(70015) 2-69-15',
      formatted: '+7 700 152-69-15',
      raw: '+77001526915',
    },
    {
      phone: '(700) 172-80-18, (778) 003-71-44',
      formatted: '+7 778 003-71-44',
      raw: '+77780037144',
    },
    {
      phone: '(700) 173-07-03',
      formatted: '+7 700 173-07-03',
      raw: '+77001730703',
    },
    {
      phone: '(700) 180-20-19',
      formatted: '+7 700 180-20-19',
      raw: '+77001802019',
    },
    {
      phone: '(700) 186-52-22',
      formatted: '+7 700 186-52-22',
      raw: '+77001865222',
    },
    {
      phone: '(700) 190-10-01',
      formatted: '+7 700 190-10-01',
      raw: '+77001901001',
    },
    {
      phone: '(700) 195‒20‒79, (717) 257‒03‒04',
      formatted: '+7 717 257-03-04',
      raw: '+77172570304',
    },
    {
      phone: '(700) 204-10-70',
      formatted: '+7 700 204-10-70',
      raw: '+77002041070',
    },
    {
      phone: '(700) 204-20-30',
      formatted: '+7 700 204-20-30',
      raw: '+77002042030',
    },
    {
      phone: '(700) 207-07-89',
      formatted: '+7 700 207-07-89',
      raw: '+77002070789',
    },
    {
      phone: '(700) 210-03-03',
      formatted: '+7 700 210-03-03',
      raw: '+77002100303',
    },
    {
      phone: '(700) 220-80-00',
      formatted: '+7 700 220-80-00',
      raw: '+77002208000',
    },
    {
      phone: '(700) 2-22-08-10, (700) 2-22-14-04, (727) 325-02-50',
      formatted: '+7 727 325-02-50',
      raw: '+77273250250',
    },
    {
      phone: '(700) 222-76-12',
      formatted: '+7 700 222-76-12',
      raw: '+77002227612',
    },
    {
      phone: '(700) 227-10-93',
      formatted: '+7 700 227-10-93',
      raw: '+77002271093',
    },
    {
      phone: '(700) 235-54-03',
      formatted: '+7 700 235-54-03',
      raw: '+77002355403',
    },
    {
      phone: '(700) 248-60-90',
      formatted: '+7 700 248-60-90',
      raw: '+77002486090',
    },
    {
      phone: '(700) 252-47-05',
      formatted: '+7 700 252-47-05',
      raw: '+77002524705',
    },
    {
      phone: '(7002) 561-77-99',
      formatted: '+7 002 561-77-99',
      raw: '+70025617799',
    },
    {
      phone: '(700) 265-38-42',
      formatted: '+7 700 265-38-42',
      raw: '+77002653842',
    },
    {
      phone: '(700) 271-35-87',
      formatted: '+7 700 271-35-87',
      raw: '+77002713587',
    },
    {
      phone: '(700) 274-19-77',
      formatted: '+7 700 274-19-77',
      raw: '+77002741977',
    },
    {
      phone: '(700) 290-29-07',
      formatted: '+7 700 290-29-07',
      raw: '+77002902907',
    },
    {
      phone: '(700) 296‒60‒40',
      formatted: '+7 700 296-60-40',
      raw: '+77002966040',
    },
    {
      phone: '(700) 298-38-35',
      formatted: '+7 700 298-38-35',
      raw: '+77002983835',
    },
    {
      phone: '(700) 300-21-24',
      formatted: '+7 700 300-21-24',
      raw: '+77003002124',
    },
    {
      phone: '(700) 300–50–58',
      formatted: '+7 700 300-50-58',
      raw: '+77003005058',
    },
    {
      phone: '(700) 300-70-69',
      formatted: '+7 700 300-70-69',
      raw: '+77003007069',
    },
    {
      phone: '(700) 303-03-34',
      formatted: '+7 700 303-03-34',
      raw: '+77003030334',
    },
    {
      phone: '(700) 303‒09‒03',
      formatted: '+7 700 303-09-03',
      raw: '+77003030903',
    },
    {
      phone: '(700) 303-40-60, (702) 007-40-60',
      formatted: '+7 702 007-40-60',
      raw: '+77020074060',
    },
    {
      phone: '(700) 309-25-09',
      formatted: '+7 700 309-25-09',
      raw: '+77003092509',
    },
    {
      phone: '(700) 310-20-20',
      formatted: '+7 700 310-20-20',
      raw: '+77003102020',
    },
    {
      phone: '(700) 310‒98‒88',
      formatted: '+7 700 310-98-88',
      raw: '+77003109888',
    },
    {
      phone: '(700) 313-11-13, (727) 313-11-13',
      formatted: '+7 727 313-11-13',
      raw: '+77273131113',
    },
    {
      phone: '(700) 315‒09‒54',
      formatted: '+7 700 315-09-54',
      raw: '+77003150954',
    },
    {
      phone: '(700) 320-3232',
      formatted: '+7 700 320-32-32',
      raw: '+77003203232',
    },
    {
      phone: '(700) 321-03-00',
      formatted: '+7 700 321-03-00',
      raw: '+77003210300',
    },
    {
      phone: '(700) 333-90-03',
      formatted: '+7 700 333-90-03',
      raw: '+77003339003',
    },
    {
      phone: '(700) 336-78-86',
      formatted: '+7 700 336-78-86',
      raw: '+77003367886',
    },
    {
      phone: '(700) 339‒99‒01',
      formatted: '+7 700 339-99-01',
      raw: '+77003399901',
    },
    {
      phone: '(700) 347-03-03',
      formatted: '+7 700 347-03-03',
      raw: '+77003470303',
    },
    {
      phone: '(700) 348‒17‒27',
      formatted: '+7 700 348-17-27',
      raw: '+77003481727',
    },
    {
      phone: '(700) 35-08-08',
      formatted: '(700) 35-08-08',
      raw: '700350808',
    },
    {
      phone: '(700) 355-00-00',
      formatted: '+7 700 355-00-00',
      raw: '+77003550000',
    },
    {
      phone: '(700) 389-78-78',
      formatted: '+7 700 389-78-78',
      raw: '+77003897878',
    },
    {
      phone: '(700) 400-07-09',
      formatted: '+7 700 400-07-09',
      raw: '+77004000709',
    },
    {
      phone: '(700) 400-33-33',
      formatted: '+7 700 400-33-33',
      raw: '+77004003333',
    },
    {
      phone: '(700) 400‒33‒33',
      formatted: '+7 700 400-33-33',
      raw: '+77004003333',
    },
    {
      phone: '(70040) 0-33-33',
      formatted: '+7 700 400-33-33',
      raw: '+77004003333',
    },
    {
      phone: '(700) 402-30-66',
      formatted: '+7 700 402-30-66',
      raw: '+77004023066',
    },
    {
      phone: '(700) 404-90-92',
      formatted: '+7 700 404-90-92',
      raw: '+77004049092',
    },
    {
      phone: '(700) 415-87-03',
      formatted: '+7 700 415-87-03',
      raw: '+77004158703',
    },
    {
      phone: '(700) 416-06-87',
      formatted: '+7 700 416-06-87',
      raw: '+77004160687',
    },
    {
      phone: '(700) 420‒05‒44',
      formatted: '+7 700 420-05-44',
      raw: '+77004200544',
    },
    {
      phone: '(700) 424-30-10',
      formatted: '+7 700 424-30-10',
      raw: '+77004243010',
    },
    {
      phone: '(700) 427-45-66',
      formatted: '+7 700 427-45-66',
      raw: '+77004274566',
    },
    {
      phone: '(700) 430-31-03',
      formatted: '+7 700 430-31-03',
      raw: '+77004303103',
    },
    {
      phone: '(700) 430-45-44',
      formatted: '+7 700 430-45-44',
      raw: '+77004304544',
    },
  ],
  MD: [
    {
      phone: '022 (067) 56 22 11',
      formatted: '+373 675 6-22-11',
      raw: '+37367562211',
    },
    {
      phone: '022 105 677 / 060 100 677',
      formatted: '+373 601 0-06-77',
      raw: '+37360100677',
    },
    {
      phone: '022 22 04 04',
      formatted: '+373 222 2-04-04',
      raw: '+37322220404',
    },
    {
      phone: '078 23 03 03',
      formatted: '+373 782 3-03-03',
      raw: '+37378230303',
    },
    {
      phone: '(3730 222 7-05-25',
      formatted: '+373 222 7-05-25',
      raw: '+37322270525',
    },
    {
      phone: '(373) 220 0-06-32',
      formatted: '+373 220 0-06-32',
      raw: '+37322000632',
    },
    {
      phone: '(373) 220 0-07-00',
      formatted: '+373 220 0-07-00',
      raw: '+37322000700',
    },
    {
      phone: '(373) 220 0-11-22',
      formatted: '+373 220 0-11-22',
      raw: '+37322001122',
    },
    {
      phone: '(373) 22 00-65-00',
      formatted: '+373 220 0-65-00',
      raw: '+37322006500',
    },
    {
      phone: '(373) 220 1-10-50',
      formatted: '+373 220 1-10-50',
      raw: '+37322011050',
    },
    {
      phone: '(373) 22 011-107',
      formatted: '+373 220 1-11-07',
      raw: '+37322011107',
    },
    {
      phone: '(373) 220 3-02-22',
      formatted: '+373 220 3-02-22',
      raw: '+37322030222',
    },
    {
      phone: '(373) 221 0-04-00',
      formatted: '+373 221 0-04-00',
      raw: '+37322100400',
    },
    {
      phone: '(373) 221 0-50-52',
      formatted: '+373 221 0-50-52',
      raw: '+37322105052',
    },
    {
      phone: '(373) 221 0-99-00',
      formatted: '+373 221 0-99-00',
      raw: '+37322109900',
    },
    {
      phone: '(373) 221 1-10-61',
      formatted: '+373 221 1-10-61',
      raw: '+37322111061',
    },
    {
      phone: '(373) 222 0-00-00',
      formatted: '+373 222 0-00-00',
      raw: '+37322200000',
    },
    {
      phone: '+373 (22) 202 373',
      formatted: '+373 222 0-23-73',
      raw: '+37322202373',
    },
    {
      phone: '(373) 222 0-57-56',
      formatted: '+373 222 0-57-56',
      raw: '+37322205756',
    },
    {
      phone: '(373) 22 20-88-90',
      formatted: '+373 222 0-88-90',
      raw: '+37322208890',
    },
    {
      phone: '(373) 222 1-04-47',
      formatted: '+373 222 1-04-47',
      raw: '+37322210447',
    },
    {
      phone: '(373) 222 1-08-37',
      formatted: '+373 222 1-08-37',
      raw: '+37322210837',
    },
    {
      phone: '(373) 222 2-07-09',
      formatted: '+373 222 2-07-09',
      raw: '+37322220709',
    },
    {
      phone: '(373) 222 2-22-13',
      formatted: '+373 222 2-22-13',
      raw: '+37322222213',
    },
    {
      phone: '(373) 222 2-55-32',
      formatted: '+373 222 2-55-32',
      raw: '+37322225532',
    },
    {
      phone: '(373) 22 225-584',
      formatted: '+373 222 2-55-84',
      raw: '+37322225584',
    },
    {
      phone: '(373) 222 2-58-37',
      formatted: '+373 222 2-58-37',
      raw: '+37322225837',
    },
    {
      phone: '(373) 222 3-32-33',
      formatted: '+373 222 3-32-33',
      raw: '+37322233233',
    },
    {
      phone: '(373) 222 3-37-55',
      formatted: '+373 222 3-37-55',
      raw: '+37322233755',
    },
    {
      phone: '(373) 222 3-52-63',
      formatted: '+373 222 3-52-63',
      raw: '+37322235263',
    },
    {
      phone: '(373) 222 3-88-55',
      formatted: '+373 222 3-88-55',
      raw: '+37322238855',
    },
    {
      phone: '(373) 222 4-03-03',
      formatted: '+373 222 4-03-03',
      raw: '+37322240303',
    },
    {
      phone: '(373) 222 4-21-42',
      formatted: '+373 222 4-21-42',
      raw: '+37322242142',
    },
    {
      phone: '(373) 222 4-23-69',
      formatted: '+373 222 4-23-69',
      raw: '+37322242369',
    },
    {
      phone: '(373) 222 4-24-80',
      formatted: '+373 222 4-24-80',
      raw: '+37322242480',
    },
    {
      phone: '(373) 22 24-37-78',
      formatted: '+373 222 4-37-78',
      raw: '+37322243778',
    },
    {
      phone: '(373) 222 5-07-04',
      formatted: '+373 222 5-07-04',
      raw: '+37322250704',
    },
    {
      phone: '(373) 222 5-15-59',
      formatted: '+373 222 5-15-59',
      raw: '+37322251559',
    },
    {
      phone: '(373) 222 6-00-70',
      formatted: '+373 222 6-00-70',
      raw: '+37322260070',
    },
    {
      phone: '+373 22 260 325',
      formatted: '+373 222 6-03-25',
      raw: '+37322260325',
    },
    {
      phone: '(373) 222 6-03-99',
      formatted: '+373 222 6-03-99',
      raw: '+37322260399',
    },
    {
      phone: '(373) 22 260-500',
      formatted: '+373 222 6-05-00',
      raw: '+37322260500',
    },
    {
      phone: '(373) 222 6-38-88',
      formatted: '+373 222 6-38-88',
      raw: '+37322263888',
    },
    {
      phone: '(373) 22 267-047',
      formatted: '+373 222 6-70-47',
      raw: '+37322267047',
    },
    {
      phone: '(373) 222 7-04-90',
      formatted: '+373 222 7-04-90',
      raw: '+37322270490',
    },
    {
      phone: '(373) 222 7-06-41',
      formatted: '+373 222 7-06-41',
      raw: '+37322270641',
    },
    {
      phone: '+373 22 270675',
      formatted: '+373 222 7-06-75',
      raw: '+37322270675',
    },
    {
      phone: '(373) 222 7-41-43',
      formatted: '+373 222 7-41-43',
      raw: '+37322274143',
    },
    {
      phone: '(373) 222 7-43-98',
      formatted: '+373 222 7-43-98',
      raw: '+37322274398',
    },
    {
      phone: '(373) 222 7-65-87',
      formatted: '+373 222 7-65-87',
      raw: '+37322276587',
    },
    {
      phone: '(373) 222 8-62-70',
      formatted: '+373 222 8-62-70',
      raw: '+37322286270',
    },
    {
      phone: '(373) 22 290-190',
      formatted: '+373 222 9-01-90',
      raw: '+37322290190',
    },
    {
      phone: '(373) 22 292-652',
      formatted: '+373 222 9-26-52',
      raw: '+37322292652',
    },
    {
      phone: '(373) 222 9-41-05',
      formatted: '+373 222 9-41-05',
      raw: '+37322294105',
    },
    {
      phone: '(373) 222 9-62-02',
      formatted: '+373 222 9-62-02',
      raw: '+37322296202',
    },
    {
      phone: '(373) 223 1-11-31',
      formatted: '+373 223 1-11-31',
      raw: '+37322311131',
    },
    {
      phone: '(373) 22 339-021',
      formatted: '+373 223 3-90-21',
      raw: '+37322339021',
    },
    {
      phone: '+373 22 40 00 40',
      formatted: '+373 224 0-00-40',
      raw: '+37322400040',
    },
    {
      phone: '+(373) 22 403 622',
      formatted: '+373 224 0-36-22',
      raw: '+37322403622',
    },
    {
      phone: '(373) 22 440-137',
      formatted: '+373 224 4-01-37',
      raw: '+37322440137',
    },
    {
      phone: '(373) 224 4-18-26',
      formatted: '+373 224 4-18-26',
      raw: '+37322441826',
    },
    {
      phone: '(373) 22 443-111',
      formatted: '+373 224 4-31-11',
      raw: '+37322443111',
    },
    {
      phone: '(373) 224 4-57-58',
      formatted: '+373 224 4-57-58',
      raw: '+37322445758',
    },
    {
      phone: '(373) 224 4-86-16',
      formatted: '+373 224 4-86-16',
      raw: '+37322448616',
    },
    {
      phone: '(373) 22 464-464',
      formatted: '+373 224 6-44-64',
      raw: '+37322464464',
    },
    {
      phone: '(373) 224 7-03-05',
      formatted: '+373 224 7-03-05',
      raw: '+37322470305',
    },
    {
      phone: '(373) 224 7-17-30',
      formatted: '+373 224 7-17-30',
      raw: '+37322471730',
    },
    {
      phone: '(373) 224 7-17-90',
      formatted: '+373 224 7-17-90',
      raw: '+37322471790',
    },
    {
      phone: '(373) 224 9-14-90',
      formatted: '+373 224 9-14-90',
      raw: '+37322491490',
    },
    {
      phone: '(373) 22 508-945',
      formatted: '+373 225 0-89-45',
      raw: '+37322508945',
    },
    {
      phone: '(373) 225 1-15-00',
      formatted: '+373 225 1-15-00',
      raw: '+37322511500',
    },
    {
      phone: '(373) 225 2-81-52',
      formatted: '+373 225 2-81-52',
      raw: '+37322528152',
    },
    {
      phone: '(373) 22 534-190',
      formatted: '+373 225 3-41-90',
      raw: '+37322534190',
    },
    {
      phone: '(373) 225 4-28-79',
      formatted: '+373 225 4-28-79',
      raw: '+37322542879',
    },
    {
      phone: '(373) 225 4-35-55',
      formatted: '+373 225 4-35-55',
      raw: '+37322543555',
    },
    {
      phone: '(373) 225 4-43-14',
      formatted: '+373 225 4-43-14',
      raw: '+37322544314',
    },
    {
      phone: '+373 22 546 400',
      formatted: '+373 225 4-64-00',
      raw: '+37322546400',
    },
    {
      phone: '(373) 225 5-61-65',
      formatted: '+373 225 5-61-65',
      raw: '+37322556165',
    },
    {
      phone: '(373) 225 5-83-65',
      formatted: '+373 225 5-83-65',
      raw: '+37322558365',
    },
    {
      phone: '(373) 225 5-95-59',
      formatted: '+373 225 5-95-59',
      raw: '+37322559559',
    },
    {
      phone: '(373) 225 6-07-60',
      formatted: '+373 225 6-07-60',
      raw: '+37322560760',
    },
    {
      phone: '(373) 225 6-92-93',
      formatted: '+373 225 6-92-93',
      raw: '+37322569293',
    },
    {
      phone: '(373) 225 7-34-64',
      formatted: '+373 225 7-34-64',
      raw: '+37322573464',
    },
    {
      phone: '(373) 225 7-36-50',
      formatted: '+373 225 7-36-50',
      raw: '+37322573650',
    },
    {
      phone: '(373) 225 8-02-59',
      formatted: '+373 225 8-02-59',
      raw: '+37322580259',
    },
    {
      phone: '(373) 22 58-25-24',
      formatted: '+373 225 8-25-24',
      raw: '+37322582524',
    },
    {
      phone: '(373) 22 58-34-78',
      formatted: '+373 225 8-34-78',
      raw: '+37322583478',
    },
    {
      phone: '(373) 225 9-25-01',
      formatted: '+373 225 9-25-01',
      raw: '+37322592501',
    },
    {
      phone: '+373 (22) 606-101',
      formatted: '+373 226 0-61-01',
      raw: '+37322606101',
    },
    {
      phone: '(373) 226 2-23-24',
      formatted: '+373 226 2-23-24',
      raw: '+37322622324',
    },
    {
      phone: '(373) 22 63-81-81',
      formatted: '+373 226 3-81-81',
      raw: '+37322638181',
    },
    {
      phone: '(373) 226 6-72-66',
      formatted: '+373 226 6-72-66',
      raw: '+37322667266',
    },
    {
      phone: '(373) 226 6-77-54',
      formatted: '+373 226 6-77-54',
      raw: '+37322667754',
    },
    {
      phone: '(373) 227 2-57-03',
      formatted: '+373 227 2-57-03',
      raw: '+37322725703',
    },
    {
      phone: '(373) 227 2-75-11',
      formatted: '+373 227 2-75-11',
      raw: '+37322727511',
    },
    {
      phone: '(373) 22 727-673',
      formatted: '+373 227 2-76-73',
      raw: '+37322727673',
    },
    {
      phone: '(373) 227 2-77-39',
      formatted: '+373 227 2-77-39',
      raw: '+37322727739',
    },
    {
      phone: '(373) 227 2-80-00',
      formatted: '+373 227 2-80-00',
      raw: '+37322728000',
    },
    {
      phone: '(373) 227 3-30-83',
      formatted: '+373 227 3-30-83',
      raw: '+37322733083',
    },
    {
      phone: '(373) 227 4-34-13',
      formatted: '+373 227 4-34-13',
      raw: '+37322743413',
    },
  ],
  TJ: [
    {
      phone: '(101) 52-55-55',
      formatted: '+992 10 152-5555',
      raw: '+992101525555',
    },
    {
      phone: '(11) 55-555-05',
      formatted: '+992 11 555-5505',
      raw: '+992115555505',
    },
    {
      phone: '(31) 302-62-39',
      formatted: '+992 31 302-6239',
      raw: '+992313026239',
    },
    {
      phone: '(3222) 2-20-02',
      formatted: '+992 32 222-2002',
      raw: '+992322222002',
    },
    {
      phone: '(383) 383-25-05',
      formatted: '+992 83 383-2505',
      raw: '+992833832505',
    },
    {
      phone: '(44) 601-90-16',
      formatted: '+992 44 601-9016',
      raw: '+992446019016',
    },
    {
      phone: '(44) 640-55-51',
      formatted: '+992 44 640-5551',
      raw: '+992446405551',
    },
    {
      phone: '(48) 703-13-13',
      formatted: '+992 48 703-1313',
      raw: '+992487031313',
    },
    {
      phone: '(55) 586-26-26',
      formatted: '+992 55 586-2626',
      raw: '+992555862626',
    },
    {
      phone: '(90) 470-59-59',
      formatted: '+992 90 470-5959',
      raw: '+992904705959',
    },
    {
      phone: '(92) 000-04-00',
      formatted: '+992 92 000-0400',
      raw: '+992920000400',
    },
    {
      phone: '(92) 110-88-99',
      formatted: '+992 92 110-8899',
      raw: '+992921108899',
    },
    {
      phone: '(92) 200-30-03',
      formatted: '+992 92 200-3003',
      raw: '+992922003003',
    },
    {
      phone: '(92) 300-03-03',
      formatted: '+992 92 300-0303',
      raw: '+992923000303',
    },
    {
      phone: '(92) 333-33-01',
      formatted: '+992 92 333-3301',
      raw: '+992923333301',
    },
    {
      phone: '(92) 440-90-90',
      formatted: '+992 92 440-9090',
      raw: '+992924409090',
    },
    {
      phone: '(92) 500-00-10',
      formatted: '+992 92 500-0010',
      raw: '+992925000010',
    },
    {
      phone: '(926) 66-44-29, (92) 714-25-55',
      formatted: '+992 92 714-2555',
      raw: '+992927142555',
    },
    {
      phone: '(92) 777-47-47',
      formatted: '+992 92 777-4747',
      raw: '+992927774747',
    },
    {
      phone: '(92) 790-00-79',
      formatted: '+992 92 790-0079',
      raw: '+992927900079',
    },
    {
      phone: '(92) 826-77-33',
      formatted: '+992 92 826-7733',
      raw: '+992928267733',
    },
    {
      phone: '(92) 832-00-94',
      formatted: '+992 92 832-0094',
      raw: '+992928320094',
    },
    {
      phone: '(92) 870-95-95',
      formatted: '+992 92 870-9595',
      raw: '+992928709595',
    },
    {
      phone: '(928) 74-00-11',
      formatted: '+992 92 874-0011',
      raw: '+992928740011',
    },
    {
      phone: '(928) 97-00-42',
      formatted: '+992 92 897-0042',
      raw: '+992928970042',
    },
    {
      phone: '(92) 917-38-64',
      formatted: '+992 92 917-3864',
      raw: '+992929173864',
    },
    {
      phone: '(92) 946-88-88',
      formatted: '+992 92 946-8888',
      raw: '+992929468888',
    },
    {
      phone: '(92) 957-33-66, (98) 957-33-66',
      formatted: '+992 98 957-3366',
      raw: '+992989573366',
    },
    {
      phone: '(93) 505-76-43',
      formatted: '+992 93 505-7643',
      raw: '+992935057643',
    },
    {
      phone: '(992) 000 00-91-03',
      formatted: '+992 00 000-9103',
      raw: '+992000009103',
    },
    {
      phone: '(+992) 000220044',
      formatted: '+992 00 022-0044',
      raw: '+992000220044',
    },
    {
      phone: '(992) 003 00-30-28',
      formatted: '+992 00 300-3028',
      raw: '+992003003028',
    },
    {
      phone: '+992 003 33 53 53',
      formatted: '+992 00 333-5353',
      raw: '+992003335353',
    },
    {
      phone: '(99207) 794-18-18',
      formatted: '+992 07 794-1818',
      raw: '+992077941818',
    },
    {
      phone: '(992) 101-30-30-30',
      formatted: '+992 10 130-3030',
      raw: '+992101303030',
    },
    {
      phone: '(992) 10 500 0003',
      formatted: '+992 10 500-0003',
      raw: '+992105000003',
    },
    {
      phone: '(992) 11 188-80-59',
      formatted: '+992 11 188-8059',
      raw: '+992111888059',
    },
    {
      phone: '(992) 115 00-03-03',
      formatted: '+992 11 500-0303',
      raw: '+992115000303',
    },
    {
      phone: '(992) 3002-8-8888',
      formatted: '+992 30 028-8888',
      raw: '+992300288888',
    },
    {
      phone: '992 (3222) 2-18-18',
      formatted: '+992 32 222-1818',
      raw: '+992322221818',
    },
    {
      phone: '(992) 3422 6-31-07',
      formatted: '+992 34 226-3107',
      raw: '+992342263107',
    },
    {
      phone: '992 (3454) 2-21-31',
      formatted: '+992 34 542-2131',
      raw: '+992345422131',
    },
    {
      phone: '(99234) 755-37-43',
      formatted: '+992 34 755-3743',
      raw: '+992347553743',
    },
    {
      phone: '(99234) 755-86-31',
      formatted: '+992 34 755-8631',
      raw: '+992347558631',
    },
    {
      phone: '(992) 372 21-15-83',
      formatted: '+992 37 221-1583',
      raw: '+992372211583',
    },
    {
      phone: '(992) 372 21 33 31',
      formatted: '+992 37 221-3331',
      raw: '+992372213331',
    },
    {
      phone: '(992) 37 221-41-32',
      formatted: '+992 37 221-4132',
      raw: '+992372214132',
    },
    {
      phone: '(992) 372 23-01-91',
      formatted: '+992 37 223-0191',
      raw: '+992372230191',
    },
    {
      phone: '(992) 372-23-02-94',
      formatted: '+992 37 223-0294',
      raw: '+992372230294',
    },
    {
      phone: '(992) 372 23-18-44',
      formatted: '+992 37 223-1844',
      raw: '+992372231844',
    },
    {
      phone: '(992) 37 223-3333',
      formatted: '+992 37 223-3333',
      raw: '+992372233333',
    },
    {
      phone: '(992) 372 236-85-52',
      formatted: '+992 72 236-8552',
      raw: '+992722368552',
    },
    {
      phone: '(992) 372 24-19-82',
      formatted: '+992 37 224-1982',
      raw: '+992372241982',
    },
    {
      phone: '+992 37 224 3092',
      formatted: '+992 37 224-3092',
      raw: '+992372243092',
    },
    {
      phone: '(992) 372 25-54-30',
      formatted: '+992 37 225-5430',
      raw: '+992372255430',
    },
    {
      phone: '(992) 372 26-60-63',
      formatted: '+992 37 226-6063',
      raw: '+992372266063',
    },
    {
      phone: '(992) 372-27-18-14',
      formatted: '+992 37 227-1814',
      raw: '+992372271814',
    },
    {
      phone: '(992) 372 27-98-24',
      formatted: '+992 37 227-9824',
      raw: '+992372279824',
    },
    {
      phone: '(992) 372 29-42-84',
      formatted: '+992 37 229-4284',
      raw: '+992372294284',
    },
    {
      phone: '(992) 372-31-25-86',
      formatted: '+992 37 231-2586',
      raw: '+992372312586',
    },
    {
      phone: '(992) 372 32-96-47',
      formatted: '+992 37 232-9647',
      raw: '+992372329647',
    },
    {
      phone: '(992) 372 33-27-27',
      formatted: '+992 37 233-2727',
      raw: '+992372332727',
    },
    {
      phone: '(992) 372 33-48-03',
      formatted: '+992 37 233-4803',
      raw: '+992372334803',
    },
    {
      phone: '(992) 372 33-59-62',
      formatted: '+992 37 233-5962',
      raw: '+992372335962',
    },
    {
      phone: '(992) 372 34-27-89',
      formatted: '+992 37 234-2789',
      raw: '+992372342789',
    },
    {
      phone: '(992) 37 234-40-56',
      formatted: '+992 37 234-4056',
      raw: '+992372344056',
    },
    {
      phone: '(992) 372 34-54-75',
      formatted: '+992 37 234-5475',
      raw: '+992372345475',
    },
    {
      phone: '(992) 372 34-78-91',
      formatted: '+992 37 234-7891',
      raw: '+992372347891',
    },
    {
      phone: '(992) 372 36-11-11',
      formatted: '+992 37 236-1111',
      raw: '+992372361111',
    },
    {
      phone: '(992) 372 36-44-61',
      formatted: '+992 37 236-4461',
      raw: '+992372364461',
    },
    {
      phone: '(992) 372 36-51-80',
      formatted: '+992 37 236-5180',
      raw: '+992372365180',
    },
    {
      phone: '(99237) 236-59-31',
      formatted: '+992 37 236-5931',
      raw: '+992372365931',
    },
    {
      phone: '(992) 372 36-79-25',
      formatted: '+992 37 236-7925',
      raw: '+992372367925',
    },
    {
      phone: '(992) 372 40-30-43',
      formatted: '+992 37 240-3043',
      raw: '+992372403043',
    },
    {
      phone: '(99241) 180-55-55',
      formatted: '+992 41 180-5555',
      raw: '+992411805555',
    },
    {
      phone: '+(992 43) 377 0303',
      formatted: '+992 43 377-0303',
      raw: '+992433770303',
    },
    {
      phone: '(992) 446-00-11-00',
      formatted: '+992 44 600-1100',
      raw: '+992446001100',
    },
    {
      phone: '(992) 44 600-51-67',
      formatted: '+992 44 600-5167',
      raw: '+992446005167',
    },
    {
      phone: '+992 44 601 11 16',
      formatted: '+992 44 601-1116',
      raw: '+992446011116',
    },
    {
      phone: '(992) 44 601-90-16',
      formatted: '+992 44 601-9016',
      raw: '+992446019016',
    },
    {
      phone: '(992) 446-01-90-16',
      formatted: '+992 44 601-9016',
      raw: '+992446019016',
    },
    {
      phone: '(99244) 601-90-16',
      formatted: '+992 44 601-9016',
      raw: '+992446019016',
    },
    {
      phone: '992 (44) 601-90-16',
      formatted: '+992 44 601-9016',
      raw: '+992446019016',
    },
    {
      phone: '992 (44) 61-90-16',
      formatted: '+992 24 461-9016',
      raw: '+992244619016',
    },
    {
      phone: '(99244) 620-33-55',
      formatted: '+992 44 620-3355',
      raw: '+992446203355',
    },
    {
      phone: '(992) 446 20-55-11',
      formatted: '+992 44 620-5511',
      raw: '+992446205511',
    },
    {
      phone: '(992) 44 630-70-70',
      formatted: '+992 44 630-7070',
      raw: '+992446307070',
    },
    {
      phone: '(+992) 44 640 01 02',
      formatted: '+992 44 640-0102',
      raw: '+992446400102',
    },
    {
      phone: '(992) 44 640 01 02',
      formatted: '+992 44 640-0102',
      raw: '+992446400102',
    },
    {
      phone: '(992) 44 640-55-51',
      formatted: '+992 44 640-5551',
      raw: '+992446405551',
    },
    {
      phone: '+992 446 60 66 00',
      formatted: '+992 44 660-6600',
      raw: '+992446606600',
    },
    {
      phone: '(992) 48 601-90-16',
      formatted: '+992 48 601-9016',
      raw: '+992486019016',
    },
    {
      phone: '(992) 48 702-12-34',
      formatted: '+992 48 702-1234',
      raw: '+992487021234',
    },
    {
      phone: '(99248) 703-13-13',
      formatted: '+992 48 703-1313',
      raw: '+992487031313',
    },
    {
      phone: '+992 48 703 13 13',
      formatted: '+992 48 703-1313',
      raw: '+992487031313',
    },
    {
      phone: '992 48 703 13 13',
      formatted: '+992 48 703-1313',
      raw: '+992487031313',
    },
    {
      phone: '(992) 505-05-01-11',
      formatted: '+992 50 505-0111',
      raw: '+992505050111',
    },
    {
      phone: '+992 550 113333',
      formatted: '+992 55 011-3333',
      raw: '+992550113333',
    },
    {
      phone: '(992) 554 22-22-24',
      formatted: '+992 55 422-2224',
      raw: '+992554222224',
    },
    {
      phone: '(992) 555 00-77-11',
      formatted: '+992 55 500-7711',
      raw: '+992555007711',
    },
  ],
  UZ: [
    {
      phone: '(0366) 210-00-41, (0366) 210-00-42',
      formatted: '+998 66 210-00-42',
      raw: '+998662100042',
    },
    {
      phone: '(55) 202-00-01',
      formatted: '+998 55 202-00-01',
      raw: '+998552020001',
    },
    {
      phone: '(67) 225-00-87',
      formatted: '+998 67 225-00-87',
      raw: '+998672250087',
    },
    {
      phone: '(67) 226-38-20',
      formatted: '+998 67 226-38-20',
      raw: '+998672263820',
    },
    {
      phone: '(67) 227-11-78',
      formatted: '+998 67 227-11-78',
      raw: '+998672271178',
    },
    {
      phone: '(67) 227-27-56, (67) 227-37-43',
      formatted: '+998 67 227-37-43',
      raw: '+998672273743',
    },
    {
      phone: '(67) 236-03-03, (94) 350-77-55',
      formatted: '+998 94 350-77-55',
      raw: '+998943507755',
    },
    {
      phone: '(67) 236-21-21, (90) 400-05-03',
      formatted: '+998 90 400-05-03',
      raw: '+998904000503',
    },
    {
      phone: '(71) 207-65-56',
      formatted: '+998 71 207-65-56',
      raw: '+998712076556',
    },
    {
      phone: '(90) 949-97-21, (97) 885-10-58',
      formatted: '+998 97 885-10-58',
      raw: '+998978851058',
    },
    {
      phone: '(91) 505-79-53, (91) 505-79-53',
      formatted: '+998 91 505-79-53',
      raw: '+998915057953',
    },
    {
      phone: '(91) 637-36-36',
      formatted: '+998 91 637-36-36',
      raw: '+998916373636',
    },
    {
      phone: '94 656-85-82',
      formatted: '+998 94 656-85-82',
      raw: '+998946568582',
    },
    {
      phone: '(95) 203-00-01',
      formatted: '+998 95 203-00-01',
      raw: '+998952030001',
    },
    {
      phone: '(95) 204-40-04',
      formatted: '+998 95 204-40-04',
      raw: '+998952044004',
    },
    {
      phone: '(95) 410-09-99',
      formatted: '+998 95 410-09-99',
      raw: '+998954100999',
    },
    {
      phone: '(95) 507-00-39',
      formatted: '+998 95 507-00-39',
      raw: '+998955070039',
    },
    {
      phone: '(9871) 267-75-41',
      formatted: '+998 71 267-75-41',
      raw: '+998712677541',
    },
    {
      phone: '(9871) 271-23-07, (9899) 461-23-01, (9897) 131-23-01',
      formatted: '+998 97 131-23-01',
      raw: '+998971312301',
    },
    {
      phone: '(9891) 925-03-03',
      formatted: '+998 91 925-03-03',
      raw: '+998919250303',
    },
    {
      phone: '(9893) 113-33-38',
      formatted: '+998 93 113-33-38',
      raw: '+998931133338',
    },
    {
      phone: '(98999) 502-88-82',
      formatted: '+998 99 502-88-82',
      raw: '+998995028882',
    },
    {
      phone: '998 (0361) 222-60-59',
      formatted: '+998 61 222-60-59',
      raw: '+998612226059',
    },
    {
      phone: '998 (33) 080-07-77',
      formatted: '+998 33 080-07-77',
      raw: '+998330800777',
    },
    {
      phone: '998 (33) 115-00-03',
      formatted: '+998 33 115-00-03',
      raw: '+998331150003',
    },
    {
      phone: '+998 333 05 11 55',
      formatted: '+998 33 305-11-55',
      raw: '+998333051155',
    },
    {
      phone: '+998 334 00 77 77',
      formatted: '+998 33 400-77-77',
      raw: '+998334007777',
    },
    {
      phone: '+998 33 450 00 03',
      formatted: '+998 33 450-00-03',
      raw: '+998334500003',
    },
    {
      phone: '998(33) 488-40-08',
      formatted: '+998 33 488-40-08',
      raw: '+998334884008',
    },
    {
      phone: '+998 33 574 07 77',
      formatted: '+998 33 574-07-77',
      raw: '+998335740777',
    },
    {
      phone: '(99833) 588-88-78',
      formatted: '+998 33 588-88-78',
      raw: '+998335888878',
    },
    {
      phone: '+998 337 51 68 62',
      formatted: '+998 33 751-68-62',
      raw: '+998337516862',
    },
    {
      phone: '+998 33 800 03 90',
      formatted: '+998 33 800-03-90',
      raw: '+998338000390',
    },
    {
      phone: '+998 33 803 00 30',
      formatted: '+998 33 803-00-30',
      raw: '+998338030030',
    },
    {
      phone: '+998 33 901 50 60',
      formatted: '+998 33 901-50-60',
      raw: '+998339015060',
    },
    {
      phone: '998 (373) 542-28-64',
      formatted: '+998 73 542-28-64',
      raw: '+998735422864',
    },
    {
      phone: '+998 55 107-00-77',
      formatted: '+998 55 107-00-77',
      raw: '+998551070077',
    },
    {
      phone: '(99855) 201-03-00',
      formatted: '+998 55 201-03-00',
      raw: '+998552010300',
    },
    {
      phone: '(99855) 201-10-00',
      formatted: '+998 55 201-10-00',
      raw: '+998552011000',
    },
    {
      phone: '(99855) 201-40-00',
      formatted: '+998 55 201-40-00',
      raw: '+998552014000',
    },
    {
      phone: '+998 55 251 42 00',
      formatted: '+998 55 251-42-00',
      raw: '+998552514200',
    },
    {
      phone: '+998 55 402 01 02',
      formatted: '+998 55 402-01-02',
      raw: '+998554020102',
    },
    {
      phone: '(99855) 452-49-90',
      formatted: '+998 55 452-49-90',
      raw: '+998554524990',
    },
    {
      phone: '(998) 555-000-556',
      formatted: '+998 55 500-05-56',
      raw: '+998555000556',
    },
    {
      phone: '(99855) 500-06-60',
      formatted: '+998 55 500-06-60',
      raw: '+998555000660',
    },
    {
      phone: '(99855) 500-28-88, (99895) 512-28-88',
      formatted: '+998 95 512-28-88',
      raw: '+998955122888',
    },
    {
      phone: '+998 55 500 31 13',
      formatted: '+998 55 500-31-13',
      raw: '+998555003113',
    },
    {
      phone: '+998 55 500 32 00',
      formatted: '+998 55 500-32-00',
      raw: '+998555003200',
    },
    {
      phone: '(99855) 500-61-00',
      formatted: '+998 55 500-61-00',
      raw: '+998555006100',
    },
    {
      phone: '(99855) 500-77-11',
      formatted: '+998 55 500-77-11',
      raw: '+998555007711',
    },
    {
      phone: '+998 (55) 500-77-87',
      formatted: '+998 55 500-77-87',
      raw: '+998555007787',
    },
    {
      phone: '+998 55 501 03 03',
      formatted: '+998 55 501-03-03',
      raw: '+998555010303',
    },
    {
      phone: '998 (55) 501-03-03',
      formatted: '+998 55 501-03-03',
      raw: '+998555010303',
    },
    {
      phone: '(99855) 501-36-63',
      formatted: '+998 55 501-36-63',
      raw: '+998555013663',
    },
    {
      phone: '(99855) 502-86-86',
      formatted: '+998 55 502-86-86',
      raw: '+998555028686',
    },
    {
      phone: '+998 55 508 00 00',
      formatted: '+998 55 508-00-00',
      raw: '+998555080000',
    },
    {
      phone: '+998 55 508 13 30',
      formatted: '+998 55 508-13-30',
      raw: '+998555081330',
    },
    {
      phone: '+998 55 508 40 40',
      formatted: '+998 55 508-40-40',
      raw: '+998555084040',
    },
    {
      phone: '+998 55 510 32 30',
      formatted: '+998 55 510-32-30',
      raw: '+998555103230',
    },
    {
      phone: '+998 55 510 36 36',
      formatted: '+998 55 510-36-36',
      raw: '+998555103636',
    },
    {
      phone: '(99855) 510-61-00',
      formatted: '+998 55 510-61-00',
      raw: '+998555106100',
    },
    {
      phone: '+998 55 511 55 22',
      formatted: '+998 55 511-55-22',
      raw: '+998555115522',
    },
    {
      phone: '+998 55 511 96 06',
      formatted: '+998 55 511-96-06',
      raw: '+998555119606',
    },
    {
      phone: '+998 555 12 21 12',
      formatted: '+998 55 512-21-12',
      raw: '+998555122112',
    },
    {
      phone: '+998 555 14 00 44',
      formatted: '+998 55 514-00-44',
      raw: '+998555140044',
    },
    {
      phone: '+998 55 514 03 33',
      formatted: '+998 55 514-03-33',
      raw: '+998555140333',
    },
    {
      phone: '+998 55 514 30 30',
      formatted: '+998 55 514-30-30',
      raw: '+998555143030',
    },
    {
      phone: '+998 55 514 55 55',
      formatted: '+998 55 514-55-55',
      raw: '+998555145555',
    },
    {
      phone: '+998 55 515 11 11',
      formatted: '+998 55 515-11-11',
      raw: '+998555151111',
    },
    {
      phone: '+998 55 515 55 22',
      formatted: '+998 55 515-55-22',
      raw: '+998555155522',
    },
    {
      phone: '+998 55 516 11 00',
      formatted: '+998 55 516-11-00',
      raw: '+998555161100',
    },
    {
      phone: '+998 55 519 50 50',
      formatted: '+998 55 519-50-50',
      raw: '+998555195050',
    },
    {
      phone: '+998 55 550 50 05',
      formatted: '+998 55 550-50-05',
      raw: '+998555505005',
    },
    {
      phone: '(99855) 601-03-05',
      formatted: '+998 55 601-03-05',
      raw: '+998556010305',
    },
    {
      phone: '998 (55) 702-01-02, 998 (55) 702-02-03',
      formatted: '+998 55 702-02-03',
      raw: '+998557020203',
    },
    {
      phone: '998 (55) 702-10-63',
      formatted: '+998 55 702-10-63',
      raw: '+998557021063',
    },
    {
      phone: '998 (55) 703-00-60, 998 (66) 233-00-60',
      formatted: '+998 66 233-00-60',
      raw: '+998662330060',
    },
    {
      phone: '998 (55) 705-08-08',
      formatted: '+998 55 705-08-08',
      raw: '+998557050808',
    },
    {
      phone: '998 61 2240333',
      formatted: '+998 61 224-03-33',
      raw: '+998612240333',
    },
    {
      phone: '998 61 224 11 17',
      formatted: '+998 61 224-11-17',
      raw: '+998612241117',
    },
    {
      phone: '998 61 226 1116',
      formatted: '+998 61 226-11-16',
      raw: '+998612261116',
    },
    {
      phone: '998 61 229 74 44',
      formatted: '+998 61 229-74-44',
      raw: '+998612297444',
    },
    {
      phone: '(99862) 223-22-66',
      formatted: '+998 62 223-22-66',
      raw: '+998622232266',
    },
    {
      phone: '(99862) 224-53-53',
      formatted: '+998 62 224-53-53',
      raw: '+998622245353',
    },
    {
      phone: '(99862) 227-70-26',
      formatted: '+998 62 227-70-26',
      raw: '+998622277026',
    },
    {
      phone: '(99862) 228-1008',
      formatted: '+998 62 228-10-08',
      raw: '+998622281008',
    },
    {
      phone: '998 65 200-03-03',
      formatted: '+998 65 200-03-03',
      raw: '+998652000303',
    },
    {
      phone: '998 (65) 220-55-58',
      formatted: '+998 65 220-55-58',
      raw: '+998652205558',
    },
    {
      phone: '998 (65) 221-91-92',
      formatted: '+998 65 221-91-92',
      raw: '+998652219192',
    },
    {
      phone: '998 (65) 221‒99‒00',
      formatted: '+998 65 221-99-00',
      raw: '+998652219900',
    },
    {
      phone: '998 65 222-60-90',
      formatted: '+998 65 222-60-90',
      raw: '+998652226090',
    },
    {
      phone: '998 (65) 222‒74‒28',
      formatted: '+998 65 222-74-28',
      raw: '+998652227428',
    },
    {
      phone: '998 (65) 223-04-41',
      formatted: '+998 65 223-04-41',
      raw: '+998652230441',
    },
    {
      phone: '998 (65) 223-05-03',
      formatted: '+998 65 223-05-03',
      raw: '+998652230503',
    },
    {
      phone: '998 (65) 223-51-23',
      formatted: '+998 65 223-51-23',
      raw: '+998652235123',
    },
    {
      phone: '(99865) 223-87-81',
      formatted: '+998 65 223-87-81',
      raw: '+998652238781',
    },
    {
      phone: '998 (65) 224-83-62',
      formatted: '+998 65 224-83-62',
      raw: '+998652248362',
    },
    {
      phone: '998 (65) 225-10-26',
      formatted: '+998 65 225-10-26',
      raw: '+998652251026',
    },
    {
      phone: '998 (65) 225-25-51',
      formatted: '+998 65 225-25-51',
      raw: '+998652252551',
    },
    {
      phone: '998 (65) 226-44-13',
      formatted: '+998 65 226-44-13',
      raw: '+998652264413',
    },
  ],
}
